// @ts-nocheck
import { CartAddEvent, CartErrorEvent, ThemeEvents } from '@theme/events';

const util = window.util;
const inlineQuantityBaselines = new WeakMap();
const preorderQuantityLimits = new WeakMap();

/* ———————————————————————————————————————— */
/* constants / contracts */
/* ———————————————————————————————————————— */

window.hasTriggeredFirstInteraction = false;

const ATTR = {
    action: 'data-action',
    activeDiscountId: 'data-active-discount-id',
    preorderActive: 'data-preorder-active',
    itemId: 'data-item-id',
    modalId: 'data-modal-id',
    modalTarget: 'data-modal-target',
    offerHandle: 'data-offer-handle',
    giftPillStyle: 'data-gift-pill-style',
    variantImageStyle: 'data-variant-image-style',
    giftSubMode: 'data-gift-sub-mode',
    giftSubProducts: 'data-gift-sub-products',
    giftSubInterval: 'data-gift-sub-interval',
    shippingPromise: 'data-shipping-promise',
    selectedMinimum: 'data-selected-minimum',
    selectedQuantity: 'data-selected-quantity',
    toggleValue: 'data-toggle-value',
    defaultTextString: 'data-default-text-string',
    configEl: 'data-offer-config',
    offerPageData: 'data-offer-page',
};

// const ACTIONS = {
//     modalOpen: 'modal:open',
//     variantLineSelect: 'variant:line-select',
//     variantSelect: 'variant:select',
// };

const CONTENT = {
    discounts: 'discounts',
    giftItems: 'gift-items',
    giftSets: 'gift-sets',
    offer: 'offer',
    preorderRules: 'preorder-rules',
    preorderShipDateRead: 'preorder-ship-date-read',
    products: 'products',
    variants: 'variants',
};

const MODAL_IDS = {
    variantSelection: 'offer-variant-selection',
};

// Currently blank, but referenced for the sake of allowing attribute preservation when required (e.g. AXON, etc.)
const ATTRIBUTE_RESET_EXCLUSIONS = [];

const SET_ATTRIBUTE_PARSERS = {
    '_offer_handle': extractPageOfferHandle,
    '_offer_applied_ts': offerEngine.parseCurrentTs,
    '_gift_pill_style': extractPageGiftPillStyle,
    '_variant_image_style': extractPageVariantImageStyle,
    '_gift_sub_mode': extractPageGiftSubMode,
    '_gift_sub_products': extractPageGiftSubProducts,
    '_gift_sub_interval': extractPageGiftSubInterval,
    '_gift_sub_offer': extractPageGiftSubOffer,
    '_shipping_promise': extractPageShippingPromise,
}

const LOCAL_ATTRIBUTE_SYNC_KEYS = {
    '_offer_handle': 'cartAttributeOffer',
    '_offer_applied_ts': 'cartOfferAppliedTs',
}

const SELECTORS = {
    offerPageRoot: 'main[data-offer-page]',
    baseQuantityInput: 'input[name="base-quantity"]',
    selectedBaseQuantity: 'input[name="base-quantity"]:checked',
    baseQuantityDisplay: '[data-content="offer-min-quantity"]',
    baseQuantityPluralization: '[data-content="offer-min-pluralization"]',
    baseQuantityOptions: '[data-content="base-quantity-options"]',
    quantityGroup: '[data-content="quantity-group"]',
    primaryVariantForm: '[data-content="variant-selection"][data-selection-type="primary"]',
    upsellVariantForm: '[data-content="variant-selection"][data-selection-type="upsell"]',
    quantityInput: 'input[ref="quantityInput"]',
    activeQuantityInputs: '[data-content="quantity-group"] input[type="number"][ref="quantityInput"]',
    lineSelectButton: `[data-action="variant:line-select"]`,
    plusButton: 'button[name="plus"]',
    minusButton: 'button[name="minus"]',
    variantSelection: '[data-content="variant-selection"]',
    addToCartButton: `[${ATTR.action}="action:add-to-cart"]`,
    modalOpenTrigger: `[${ATTR.action}="modal:open"][${ATTR.modalTarget}="${MODAL_IDS.variantSelection}"]`,
    priceSnippet: '.discount-price--snippet',
    priceValue: '.price',
    compareValue: '.compare-at-price',
    quantityComponent: 'quantity-selector-component',
    pageOfferSummary: '[data-content="offer-summary"][data-element-position="page"]',
    summaryElement: '[data-content="offer-summary"]',
    summaryValue: '[data-content="offer-value"]',
    summaryPrice: '[data-content="offer-price"]',
    summaryPreorderPrice: '[data-content="offer-price-preorder"]',
    summarySavings: '[data-content="offer-savings"]',
    summaryQuantity: '[data-content="active-quantity"]',
    summaryPluralization: '[data-content="active-pluralization"]',
    summarySavingsPercentage: '[data-content="savings-percentage"]',
    preorderActive: '[data-selection-type="primary"][data-preorder-active="true"]',
    preorderShipEstimate: '[data-content="preorder-ship-estimate"]',
    ctaButtons: [
        `.offer-page--cta[${ATTR.action}="modal:open"]`,
        `.offer-page--cta[${ATTR.action}="offer-page:direct-add"]`,
        `.offer-page--cta [${ATTR.action}="modal:open"]`,
        `.offer-page--cta [${ATTR.action}="offer-page:direct-add"]`,
        `[data-content="preorder-toggle"] [data-toggles="preorder-active"]`,
        'sticky-add-to-cart[data-context="offer-page"] [data-default-text-string]',
    ].join(', '),
    directAddButton: `[${ATTR.action}="offer-page:direct-add"]`,
    ctaTextWrapper: '[data-content="cta-primary-text"]',
    preorderToggle: '[data-toggles="preorder-active"]',
    discountSavingsAmount: '[data-content="discount-savings-amount"]',
    offerActiveQuantity: '[data-content="offer-active-quantity"]',
    selectedQuantityDisplay: '[data-content="offer-selected-quantity"]',
    selectionPriceDisplay: '[data-content="offer-selection-price"]',
    selectionValueDisplay: '[data-content="offer-selection-value"]',
    offerActivePluralization: '[data-content="active-pluralization"]',
    giftDisplay: '[data-content="gift-display"]',
    giftDisplayItem: '[data-gift-display-item]',
    giftUnlockedPill: '[data-content="gift-unlocked-count"]',
    giftUnlockedNumber: '[data-content="gift-unlocked-number"]',
    resetModalLines: '[data-subaction="modal:reset-lines"]',
    scrollTop: '[data-action="scroll:top"]',
    scrollSelection: '[data-action="scroll:selection"]',
    preorderTogglePills: '[data-content="preorder-toggle"]',
    inlineCtaLabel: '[data-content="inline-cta-label"]',
    inlineSelectionList: '.inline-variant-selection .variant-selection--list',
    lightboxOpen: '[data-lightbox-open]',
    lightboxList: '[data-lightbox-list]',
    lightboxCard: '.offer-lightbox__card',
    lightboxNav: `[${ATTR.action}="lightbox:nav"]`,
    lightboxAdd: `[${ATTR.action}="lightbox:add"]`,
    lightboxQty: `[${ATTR.action}="lightbox:qty"]`,
    variantLineRow: '.variant-selection--list .variant-line[data-display-variant-id]',
};

const INIT_FLAG = '__offerPageInit';

const INLINE_LIST_VISIBLE_ROWS = 6;

const CART_ADD_PATH = window.Theme?.routes?.cart_add_url || '/cart/add.js';
const CART_UPDATE_PATH = window.Theme?.routes?.cart_update_url || '/cart/update.js';
const CART_CHANGE_PATH = window.Theme?.routes?.cart_change_url || '/cart/change.js';
const CART_STATE_PATH = '/cart.js';
const MIN_PREORDER_DELAY_DAYS = 6;

const STATE_HANDLERS = {
    base_quantity_selection: hydrateBaseQuantitySelection,
    primary_variant_quantity: (obj = {}) => hydrateVariantQuantities('primary', obj),
    upsell_variant_quantity: (obj = {}) => hydrateVariantQuantities('upsell', obj),
};

/* ———————————————————————————————————————— */
/* module state / event config */
/* ———————————————————————————————————————— */

let stateData = {};
let paramsData = {};
let prepPromise = null;
let hasPreparedCart = false;
let hasBoundEventHandlers = false;
let hasBoundFirstInteraction = false;
let firstInteractionPrepTimer = null;

const EVENT_HANDLERS = {
    click: new Map([
        ['[data-action="offer:select-finish"]', {
            handler: handleClosingFinishSelect,
        }],
        [SELECTORS.directAddButton, {
            handler: handleDirectAddToCart,
        }],
        [SELECTORS.preorderToggle, { 
            handler: handlePreorderToggleClick,
            hydrate: true,
            hydrateAfter: true
        }],
        [SELECTORS.resetModalLines, { 
            handler: handleModalClose,
        }],
        [SELECTORS.lineSelectButton, { 
            handler: handleLineSelect,            
        }],
        [SELECTORS.addToCartButton, { 
            handler: handleAddToCart,
            hydrate: true,
        }],
        [SELECTORS.scrollTop, {
            handler: handleScrollTop,
        }],
        [SELECTORS.scrollSelection, {
            handler: handleScrollSelection,
        }],
        [SELECTORS.lightboxOpen, {
            handler: handleLightboxOpen,
        }],
        [SELECTORS.lightboxNav, {
            handler: handleLightboxNav,
        }],
        [SELECTORS.lightboxAdd, {
            handler: handleLightboxAdd,
        }],
        [SELECTORS.lightboxQty, {
            handler: handleLightboxQty,
        }],
    ]),
    change: new Map([
        [SELECTORS.baseQuantityInput, { 
            handler: handleBaseQuantityChange,
            hydrate: true,
        }],
    ]),
    input: new Map([
        [SELECTORS.quantityInput, { 
            handler: handleQuantityInput,
            hydrate: true,
        }],
    ]),
    [ThemeEvents.quantitySelectorUpdate]: new Map([
        [SELECTORS.quantityGroup, { 
            handler: handleQuantityInput,
            hydrate: true,
        }],
    ]),
    pointerdown: {
        firstInteraction: handleFirstInteractionPrep,
        options: { once: true, passive: true },
    },
    keydown: {
        firstInteraction: handleFirstInteractionPrep,
        options: { once: true, passive: false },
    },
    touchstart: {
        firstInteraction: handleFirstInteractionPrep,
        options: { once: true, passive: true },
    },
    focusin: {
        firstInteraction: handleFirstInteractionPrep,
        options: { once: true, passive: true },
    },
};

/* ———————————————————————————————————————— */
/* init / boot */
/* ———————————————————————————————————————— */

function domReady() {
    if (document.readyState !== 'loading') return Promise.resolve();
    return new Promise((resolve) => {
        document.addEventListener('DOMContentLoaded', resolve, { once: true });
    });
}

initOfferPage();

async function initOfferPage() {
    await domReady();

    try {
        initOnce();
    } catch (error) {
        console.error('[OfferPage] init failed', error);
    }
}

function initOnce() {
    if (window[INIT_FLAG]) return;
    window[INIT_FLAG] = true;
    handleHydration();
    initEventHandlers();
    initInlineListViewport();
    initInlineStickyFooter();
}

/*
Inline selection list viewport — cap the on-page list at N visible rows and let
the rest scroll. Measured from the rendered rows (heights differ by breakpoint,
and hidden/unavailable rows can be revealed by the preorder toggle) so the cut
always lands exactly after the Nth row. No-ops on modal templates.
*/
let inlineListResizeTimer = null;

function initInlineListViewport() {
    const list = document.querySelector(SELECTORS.inlineSelectionList);
    if (!list) return;

    // Show-all templates render every row in flow and the CSS keeps the list
    // overflow visible — it is never a scroll container, so none of the
    // scroll plumbing below (cap sizing, scroll hints, momentum halt, edge
    // handoff) applies. sizeInlineListViewport still guards itself for the
    // preorder-toggle call path.
    if (list.closest('[data-show-all-rows]')) return;

    sizeInlineListViewport();
    list.addEventListener('scroll', updateInlineListScrollHints, { passive: true });

    // iOS hands a touch that lands mid-momentum to the scroller already in
    // motion (the page), not the scroller under the finger — so a thumb on
    // the list keeps scrolling the page. Halting the page's momentum on
    // touchstart makes the ensuing drag a fresh gesture owned by the list.
    list.addEventListener('touchstart', () => {
        window.scrollTo(window.scrollX, window.scrollY);
    }, { passive: true });

    initInlineListEdgeHandoff(list);

    window.addEventListener('resize', () => {
        window.clearTimeout(inlineListResizeTimer);
        inlineListResizeTimer = window.setTimeout(sizeInlineListViewport, 150);
    });
}

/*
Mid-gesture edge handoff (touch): iOS never transfers an in-progress drag
from an inner scroller to the page — once the drag owns the list, exhausting
it just rubber-bands the list and the gesture dies at the edge. The CSS sets
overscroll-behavior-y:none on the list for coarse pointers, killing both the
bounce and native chaining (Chrome chains mid-gesture natively and would
double-scroll on top of a manual path), and this drives the page directly:
while the list has room the native scroll runs untouched; once the drag
pushes past the list's top/bottom, each further move scrolls the page 1:1
('instant' — base.css sets global scroll-behavior:smooth, which would turn
per-move deltas into animation mush). A release mid-handoff synthesizes the
fling the page would have had natively (iOS-style per-frame decay), cancelled
by any new touch. Gated on the same conditions as the CSS so unsupported
browsers keep fully native behavior.

Wheels need the same hand-off: overscroll-behavior:none blocks wheel
chaining too, and wheels do occur under coarse pointers (DevTools device
mode, hybrid laptops) — without this, a wheel that bottoms out the list can
never reach the page, even as a fresh gesture. At-edge deltas are natively
eaten, so forwarding them to the page cannot double-scroll — but only while
the coarse-pointer CSS rule actually applies, so the handler re-checks the
media query live: DevTools device mode can be toggled off without a reload
(and a convertible's primary pointer can flip), which resumes native
chaining while this listener is still attached.
*/
function initInlineListEdgeHandoff(list) {
    const coarsePointer = window.matchMedia('(pointer: coarse)');
    if (!coarsePointer.matches) return;
    if (!(window.CSS && CSS.supports('overscroll-behavior-y', 'none'))) return;

    let lastTouchY = null;
    let velocity = 0;          // px/ms, smoothed, only while in handoff
    let lastMoveTime = 0;
    let flingFrame = null;

    const cancelFling = () => {
        if (flingFrame !== null) window.cancelAnimationFrame(flingFrame);
        flingFrame = null;
    };
    // Any touch anywhere catches the synthetic fling, like native momentum.
    document.addEventListener('touchstart', cancelFling, { passive: true });

    list.addEventListener('touchstart', (event) => {
        lastTouchY = event.touches[0].clientY;
        lastMoveTime = event.timeStamp;
        velocity = 0;
    }, { passive: true });

    list.addEventListener('touchmove', (event) => {
        if (lastTouchY === null) return;
        const y = event.touches[0].clientY;
        const dy = lastTouchY - y; // positive: finger moved up = scroll down
        lastTouchY = y;

        const maxScroll = list.scrollHeight - list.clientHeight;
        const pastBottom = dy > 0 && list.scrollTop >= maxScroll - 1;
        const pastTop = dy < 0 && list.scrollTop <= 1;
        const dt = event.timeStamp - lastMoveTime;
        if (pastBottom || pastTop) {
            window.scrollBy({ top: dy, behavior: 'instant' });
            if (dt > 0) {
                const instantaneous = dy / dt;
                velocity = velocity === 0 ? instantaneous : instantaneous * 0.6 + velocity * 0.4;
            }
        } else {
            velocity = 0;
        }
        lastMoveTime = event.timeStamp;
    }, { passive: true });

    const endGesture = (event) => {
        if (event.touches.length > 0) return;
        lastTouchY = null;
        // A finger that rested before lifting flings nothing.
        if (event.timeStamp - lastMoveTime > 100) { velocity = 0; return; }
        let step = Math.max(-60, Math.min(60, velocity * 16.7)); // px/frame
        velocity = 0;
        if (Math.abs(step) < 4) return;
        const tick = () => {
            const before = window.scrollY;
            window.scrollBy({ top: step, behavior: 'instant' });
            step *= 0.967; // ≈ iOS UIScrollView normal deceleration per frame
            if (Math.abs(step) < 0.5 || window.scrollY === before) { flingFrame = null; return; }
            flingFrame = window.requestAnimationFrame(tick);
        };
        flingFrame = window.requestAnimationFrame(tick);
    };
    list.addEventListener('touchend', endGesture, { passive: true });
    list.addEventListener('touchcancel', (event) => {
        void event;
        lastTouchY = null;
        velocity = 0;
    }, { passive: true });

    list.addEventListener('wheel', (event) => {
        // ctrl+wheel is pinch-zoom on precision trackpads — zoom, not
        // scroll; the live coarse-pointer re-check is the double-scroll
        // guard described in the block comment above.
        if (event.ctrlKey || !coarsePointer.matches) return;
        // A wheel catches an in-flight synthetic fling exactly like a new
        // touch does — otherwise both would drive the page at once.
        cancelFling();
        // deltaMode is pixels from mice/trackpads; lines (Firefox, ~16px
        // per line by convention) and pages are normalized so the
        // forwarded distance matches the intent.
        const dy = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1);
        const maxScroll = list.scrollHeight - list.clientHeight;
        const pastBottom = dy > 0 && list.scrollTop >= maxScroll - 1;
        const pastTop = dy < 0 && list.scrollTop <= 1;
        if (pastBottom || pastTop) {
            window.scrollBy({ top: dy, behavior: 'instant' });
        }
    }, { passive: true });
}

// Scroll-shadow affordance: flag which directions still have content so the
// CSS edge fades only show where scrolling is actually possible.
function updateInlineListScrollHints() {
    const list = document.querySelector(SELECTORS.inlineSelectionList);
    const wrapper = list ? list.closest('.inline-variant-selection') : null;
    if (!list || !wrapper) return;

    const maxScroll = list.scrollHeight - list.clientHeight;
    wrapper.toggleAttribute('data-scroll-above', list.scrollTop > 2);
    wrapper.toggleAttribute('data-scroll-below', maxScroll - list.scrollTop > 2);
}

function sizeInlineListViewport() {
    const list = document.querySelector(SELECTORS.inlineSelectionList);
    if (!list) return;

    // data-list-capped marks the wrapper whenever a cap is in force — it gates
    // the "scroll for more" bar and the fades' clearance above it.
    const wrapper = list.closest('.inline-variant-selection');

    // Show-all templates render every row at full height — no cap, no scroll.
    if (list.closest('[data-show-all-rows]')) {
        list.style.maxHeight = '';
        if (wrapper) wrapper.removeAttribute('data-list-capped');
        updateInlineListScrollHints();
        return;
    }

    const rows = Array.from(list.querySelectorAll('.variant-line'))
        .filter((row) => window.getComputedStyle(row).display !== 'none')
        // Rows carry the merchant's flex `order` override, so DOM order is
        // not visual order — the cap must cut after the Nth RENDERED row.
        // (With 8 rows this only lined up by luck; at 6 it visibly broke.)
        .sort((a, b) => a.offsetTop - b.offsetTop);

    if (rows.length <= INLINE_LIST_VISIBLE_ROWS) {
        list.style.maxHeight = '';
        if (wrapper) wrapper.removeAttribute('data-list-capped');
        updateInlineListScrollHints();
        return;
    }

    // The attr goes on first: it switches the scroll bar to display:flex, and
    // the bar's measured height feeds the viewport math below.
    if (wrapper) wrapper.setAttribute('data-list-capped', '');

    // Top of row N+1 minus top of row 1 = exactly N rows plus the gaps between
    // them; then add a partial slice of row N+1 so a faded "more below" row
    // peeks out. The bar overlays the list's bottom edge, so its height is
    // added back to keep ~45% of the peek row visible above it.
    const peekRow = rows[INLINE_LIST_VISIBLE_ROWS];
    const bar = wrapper ? wrapper.querySelector('.inline-variant-selection--more') : null;
    // max-height resolves against the border box, so the list's top padding
    // (magnifier headroom) has to be counted for 6 full rows to stay visible.
    const height = peekRow.offsetTop - rows[0].offsetTop
        + Math.round(peekRow.offsetHeight * 0.45)
        + (bar ? bar.offsetHeight : 0)
        + (parseFloat(window.getComputedStyle(list).paddingTop) || 0);
    list.style.maxHeight = `${height}px`;
    updateInlineListScrollHints();
}

/*
Inline sticky footer (gifts + Select-N CTA) — the selection decides whether the
block is sticky AT ALL (see the CSS: data-footer-shown gates position:sticky;
unselected = plain static flow content, because hiding a sticky element leaves
a hole in its reserved space once that space scrolls into view). Three facts:
- pinned: a zero-height sentinel right after the footer marks its natural flow
  position. Sentinel below the viewport = a sticky footer would be riding the
  viewport bottom; sentinel visible or above = it sits at its natural place.
- shown: the live selection has at least one device in it. Driven by
  updateAddButtonState (the selection engine's single state choke point) via
  the registration hook below — NOT by the wrapper's data-selected-quantity
  attribute, which never records the drop back to zero.
- armed: sticky may only ACTIVATE while the Select-N CTA is out of view —
  its bottom edge below the fold less half a button of tolerance. With the
  CTA comfortably visible there is nothing to fix, so selecting changes
  nothing; it arms later, when scrolling carries the CTA out of view below
  (a one-way latch until the selection empties, so the settled footer never
  pops back down mid-scroll). CTA rect/observer readings are only consulted
  while unarmed, when the footer is static and they describe its natural
  position.
Selection flips and late arming that happen while pinned get a one-shot
rise/fall animation (data-footer-entering / data-footer-leaving; leaving also
holds the sticky position until the fall completes). Each shot measures the
real displacement the sticky swap causes and writes it to --op-footer-shift,
so a partly visible footer slides only the remaining distance from where it
sits instead of vanishing and re-entering from offscreen. No-ops unless
Liquid rendered the footer.
*/
let inlineStickyFooterSelectionSync = null;

// Bottom of the visible screen: innerHeight includes the strip hidden behind
// mobile browser toolbars, so prefer the visual viewport when available.
function viewportFold() {
    const vv = window.visualViewport;
    return vv ? vv.offsetTop + vv.height : window.innerHeight;
}

function initInlineStickyFooter() {
    const footer = document.querySelector('.offer-page--block.inline-sticky-footer');
    if (!footer) return;

    const cta = footer.querySelector('.inline-add-cta--button') || footer;

    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:0;margin:0;padding:0;';
    footer.insertAdjacentElement('afterend', sentinel);

    let pinned = false;
    let shown = false;
    let armed = false;

    const applyState = () => {
        footer.toggleAttribute('data-footer-pinned', pinned);
        footer.toggleAttribute('data-footer-shown', shown && armed);
    };

    // Valid only while unarmed (footer static, CTA at its natural position).
    // "Out of view" tolerates half a button of margin above the fold —
    // measured against the visual viewport (innerHeight includes the strip
    // hidden behind mobile browser toolbars) — so a CTA resting within half
    // its height of the fold still counts as out of view and arms the rise.
    const ctaOutOfView = () => {
        const rect = cta.getBoundingClientRect();
        return rect.bottom > viewportFold() - rect.height / 2;
    };

    // How far the sticky swap displaces the footer: natural bottom to the
    // fold, capped at the offscreen distance the old fixed slide covered.
    // While displaced (the leaving shot), the natural rect is recovered by
    // forcing static positioning for a same-frame read — never painted.
    const stickyShiftPx = () => {
        const inlinePosition = footer.style.position;
        footer.style.position = 'static';
        const rect = footer.getBoundingClientRect();
        footer.style.position = inlinePosition;
        return Math.max(0, Math.min(rect.bottom - viewportFold(), rect.height * 1.1));
    };

    const playSlide = (attr) => {
        const shift = stickyShiftPx();
        if (shift === 0) return;
        footer.style.setProperty('--op-footer-shift', `${shift}px`);
        footer.setAttribute(attr, '');
    };

    inlineStickyFooterSelectionSync = (selectedQuantity) => {
        const next = selectedQuantity > 0;
        if (next !== shown) {
            shown = next;
            // One-shot slide only when the flip changes sticky state while the
            // footer is displaced from its natural position; when it's settled
            // on screen the sticky<->static swap is geometrically seamless.
            footer.removeAttribute('data-footer-entering');
            footer.removeAttribute('data-footer-leaving');
            if (next) {
                if (ctaOutOfView()) {
                    armed = true;
                    if (pinned) playSlide('data-footer-entering');
                }
            } else {
                if (armed && pinned) playSlide('data-footer-leaving');
                armed = false;
            }
        }
        applyState();
    };

    footer.addEventListener('animationend', (event) => {
        if (!String(event.animationName).startsWith('op-footer')) return;
        footer.removeAttribute('data-footer-entering');
        footer.removeAttribute('data-footer-leaving');
    });

    // Hydration ran before this init, so pick up any pre-existing selection.
    const wrapper = document.querySelector(SELECTORS.variantSelection);
    shown = Number(wrapper?.getAttribute(ATTR.selectedQuantity)) > 0;
    armed = shown && ctaOutOfView();

    const sentinelObserver = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        if (!entry) return;
        pinned = !entry.isIntersecting && entry.boundingClientRect.top > 0;
        applyState();
    });
    sentinelObserver.observe(sentinel);

    // Late arming: selected while the CTA was visible, then scrolled up
    // until the CTA left the viewport below. threshold:1 fires the callback
    // on full-visibility crossings, and the rootMargin mirrors the arming
    // check's tolerance: the bottom half-button doesn't count as visible
    // screen. The rootBounds guard restricts arming to bottom-edge clipping
    // (and filters threshold:1 rounding noise on a fully visible CTA).
    const ctaObserver = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        if (!entry) return;
        if (armed || !shown) return;
        if (entry.intersectionRatio >= 1) return;
        if (entry.rootBounds && entry.boundingClientRect.bottom <= entry.rootBounds.bottom) return;
        armed = true;
        footer.removeAttribute('data-footer-leaving');
        playSlide('data-footer-entering');
        applyState();
    }, {
        rootMargin: `0px 0px -${Math.round(cta.getBoundingClientRect().height / 2)}px 0px`,
        threshold: 1,
    });
    ctaObserver.observe(cta);
    applyState();
}

function initEventHandlers() {
    if (hasBoundEventHandlers) return;
    hasBoundEventHandlers = true;

    Object.entries(EVENT_HANDLERS).forEach(([eventType, config]) => {
        if (!(config instanceof Map)) return;

        document.addEventListener(eventType, handleDelegatedDocumentEvent);
    });

    initFirstInteractionHandlers();
    window.addEventListener('pagehide', handlePageNavigation);
    window.addEventListener('pageshow', handlePageNavigation);
}

function initFirstInteractionHandlers() {
    if (hasBoundFirstInteraction) return;
    hasBoundFirstInteraction = true;

    Object.entries(EVENT_HANDLERS).forEach(([eventType, config]) => {
        const handler = config instanceof Map ? null : config?.firstInteraction;
        if (typeof handler !== 'function') return;

        document.addEventListener(eventType, handler, config?.options);
    });
}

function destroyFirstInteractionHandlers() {
    if (!hasBoundFirstInteraction) return;
    hasBoundFirstInteraction = false;

    Object.entries(EVENT_HANDLERS).forEach(([eventType, config]) => {
        const handler = config instanceof Map ? null : config?.firstInteraction;
        if (typeof handler !== 'function') return;

        document.removeEventListener(eventType, handler, config?.options);
    });
}

/* ———————————————————————————————————————— */
/* hyrdation utilities */
/* ———————————————————————————————————————— */

// High level hydration router
function handleHydration() {
    const params = Object.keys(paramsData).length > 0 ? paramsData : hydrateParams();
    const state = hydrateStateData(params);
    return {
        params,
        state,
    }
}

// Params hydration
function hydrateParams() {
    const jsonDrops = document.querySelectorAll(`[${ATTR.configEl}][${ATTR.offerPageData}]`);
    const next = offerEngine.prehydrateDrops(jsonDrops);
    filterUnavailableGiftItemVariants(next);

    if (next.variants) {
        next.highest_value_variant = extractHighestValueVariant(next.variants);
        next.lowest_price_variant = extractLowestPriceVariant(next.variants);
    }

    commitHydration(next, 'params');
    return next;
}

function filterUnavailableGiftItemVariants(params = {}) {
    if (!Array.isArray(params.gift_items) || !Array.isArray(params.gift_item_products)) return params;

    const variantsById = new Map();
    params.gift_item_products.forEach((product) => {
        (product.variants || []).forEach((variant) => {
            variantsById.set(util.normalize.number(variant.id), variant);
        });
    });

    params.gift_items.forEach((giftItem) => {
        if (!Array.isArray(giftItem.variant_ids) || !giftItem.variant_ids.length) return;

        giftItem.variant_ids = giftItem.variant_ids.filter((variantId) => {
            const variant = variantsById.get(util.normalize.number(variantId));
            return variant?.available === true;
        });
    });

    return params;
}

// Broad state hydration
function hydrateStateData(params = paramsData) {
    updateInlineQuantityPreset();
    const next = {}
    
    Object.keys(STATE_HANDLERS).forEach((stateKey) => {
        next[stateKey] = hydrateStateKey(stateKey);
    });

    next.baseline_quantity = util.compare.number.max(next.base_quantity_selection || 0, next.primary_variant_quantity || 0);
    // Set the active_discount state key
    next.active_discount = hydrateActiveDiscount({state: next, params});
    next.active_variant_price_overrides = hydrateActivePriceOverrides({discount: next.active_discount, params});

    // Handle preorder eligibility and active preorder_rules if applicable
    next.active_preorder_rules = hydrateActivePreorderRules({discount: next.active_discount, params});
    next.preorder_enabled = parsePreorderRuleState(next.active_preorder_rules) !== null;
    next.preorder_active = hydratePreorderActive();

    // NEED TO ADD UPSSELL SUPPORT
    next.active_selections = hydrateActiveSelections(next, params?.variants || []);
    next.has_unavailable_preorder_selections = next.preorder_active
        && next.active_selections.some(item => !(item.pricing?.preorder_unit > 0));
    updatePreorderVariantAvailability(next, params?.variants || []);
    next.base_selection_highest_value = hydrateBaseSelection(next, extractHighestCompareVariant(next, params?.variants || []));
    next.base_selection_lowest_price = hydrateBaseSelection(next, extractLowestOfferVariant(next, params?.variants || []));
    next.base_selection_lowest_preorder = hydrateBaseSelection(next, extractLowestPreorderVariant(next, params?.variants || []));
    // Handle gift eligibility and applicable gift items if applicable
    next.base_applicable_gifts = parseApplicableGiftItems({quantity: next.base_quantity_selection, giftItems: params?.gift_items || [], products: params?.gift_item_products || []});
    next.applicable_gifts = parseApplicableGiftItems({quantity: next.baseline_quantity, giftItems: params?.gift_items || [], products: params?.gift_item_products || []});

    updateGiftVariantSelection(next, params);
    next.price_values = parsePriceStates(next, params?.variants || []);
    next.price_display = formatMoneyDeep(next.price_values);

    commitHydration(next, 'state');
    updateClosingPurchase(next);

    return next;
}

/* Compact closing layout is a view of the primary form, never a second cart state. */
function hydrateClosingFinishSelection(closing, primary) {
    /* An untouched chooser adopts one existing featured unit. After a deliberate
       deselection, do not adopt a leftover unit of the same color again. */
    if (!closing.dataset.state) {
        const selected = Array.from(closing.querySelectorAll('[data-action="offer:select-finish"]'))
            .find((button) => {
                const row = primary.querySelector(`[data-display-variant-id="${button.dataset.variantId}"]`);
                return Number(row?.querySelector(SELECTORS.quantityInput)?.value) > 0;
            });
        if (selected) closing.dataset.state = selected.dataset.variantId;
    }
    const selectedId = closing.dataset.state;
    if (!selectedId || selectedId === 'none') return '';
    const row = primary.querySelector(`[data-display-variant-id="${selectedId}"]`);
    if (Number(row?.querySelector(SELECTORS.quantityInput)?.value) > 0) return selectedId;
    closing.dataset.state = 'none';
    return '';
}

function handleClosingFinishSelect(event, el) {
    void event;
    const primary = document.querySelector(SELECTORS.primaryVariantForm);
    const closing = el.closest('[data-closing-purchase]');
    if (!primary || !closing || el.disabled) return;
    const isUpsert = closing.dataset.closingFormInteraction === 'upsert';
    const selectedId = isUpsert ? hydrateClosingFinishSelection(closing, primary) : '';
    const isDeselecting = isUpsert && selectedId === el.dataset.variantId;
    const row = primary.querySelector(`[data-display-variant-id="${el.dataset.variantId}"]`);
    const input = row?.querySelector(SELECTORS.quantityInput);
    if (!input) return;
    if (!isDeselecting && (row.hidden || row.dataset.soldOutHidden === 'true'
        || row.dataset.statePreorderUnavailable === 'true')) return;

    const minimum = Math.max(Number(primary.dataset.selectedMinimum) || 1, 1);
    const current = Math.max(Number(input.value) || 0, 0);
    const next = isUpsert ? current + (isDeselecting ? -1 : 1) : minimum;
    const maximum = input.hasAttribute('max') ? Number(input.max) : Infinity;
    if (next > current && (maximum < next || input.readOnly)) return;
    const previousRow = selectedId
        ? primary.querySelector(`[data-display-variant-id="${selectedId}"]`) : null;
    const previousInput = previousRow?.querySelector(SELECTORS.quantityInput);
    if (isUpsert) closing.dataset.state = isDeselecting ? 'none' : el.dataset.variantId;
    primary.querySelectorAll(SELECTORS.quantityInput).forEach((other) => {
        if (other.closest('[data-gift-variant-options]')) return;
        if (isUpsert && other !== input && other !== previousInput) return;
        other.value = other === input ? String(Math.max(next, 0))
            : isUpsert ? String(Math.max((Number(other.value) || 0) - 1, 0)) : '0';
        const group = other.closest(SELECTORS.quantityGroup);
        group?.setAttribute(ATTR.selectedQuantity, other.value);
    });
    input.dispatchEvent(new Event('input', { bubbles: true }));
}

/* Reuse offer pricing for the one unit controlled below, without retained quantities or gifts. */
function parseClosingUnitPriceDisplay(state, selectedId) {
    const selection = state.active_selections?.find((item) => String(item.id) === selectedId);
    const unitSelection = (item) => item?.pricing ? {
        ...item,
        quantity: 1,
        pricing: {
            ...item.pricing,
            compare: item.pricing.compare_unit,
            offer: item.pricing.offer_unit,
            preorder: item.pricing.preorder_unit,
        },
    } : null;
    const prices = parsePriceStates({
        base_selection_highest_value: unitSelection(state.base_selection_highest_value),
        base_selection_lowest_price: unitSelection(state.base_selection_lowest_price),
        base_selection_lowest_preorder: unitSelection(state.base_selection_lowest_preorder),
        active_selections: selection ? [unitSelection(selection)] : [],
    });
    return formatMoneyDeep(selection ? prices.selections : prices.base);
}

function updateClosingPurchase(state) {
    const closing = document.querySelector('[data-closing-purchase]');
    if (!closing) return;
    const primary = document.querySelector(SELECTORS.primaryVariantForm);
    if (!primary) return;
    const minimum = Math.max(Number(primary.dataset.selectedMinimum) || 1, 1);
    const isUpsert = closing.dataset.closingFormInteraction === 'upsert';
    const selectedId = isUpsert ? hydrateClosingFinishSelection(closing, primary) : '';
    const finishStates = Array.from(closing.querySelectorAll('[data-action="offer:select-finish"]'))
        .map((button) => {
            const row = primary.querySelector(`[data-display-variant-id="${button.dataset.variantId}"]`);
            const input = row?.querySelector(SELECTORS.quantityInput);
            const current = Math.max(Number(input?.value) || 0, 0);
            const selected = isUpsert ? selectedId === button.dataset.variantId : current > 0;
            const next = isUpsert ? current + 1 : minimum;
            const maximum = input?.hasAttribute('max') ? Number(input.max) : Infinity;
            const unavailable = !row || !input || (!(isUpsert && selected) && (
                button.dataset.finishAvailable === 'false'
                || row.dataset.soldOutHidden === 'true' || row.dataset.defaultHidden === 'true'
                || row.dataset.statePreorderUnavailable === 'true'
                || row.hidden || getComputedStyle(row).display === 'none'
                || next > maximum || (input.readOnly && next > current)));
            return { button, unavailable, selected };
        });
    const hasSelection = state.primary_variant_quantity > 0;
    const values = isUpsert ? parseClosingUnitPriceDisplay(state, selectedId)
        : hasSelection ? state.price_display.selections : state.price_display.base;
    const isPreorder = state.preorder_active;
    const canAdd = state.primary_variant_quantity >= Math.max(state.base_quantity_selection, 1)
        && !state.has_unavailable_preorder_selections;
    const savingsLabel = isPreorder
        ? values.savings.percent_preorder_less_gifts : values.savings.percent_less_gifts;
    const updates = {
        '[data-closing-price]': isPreorder ? values.preorder : values.discount,
        '[data-closing-compare]': values.compare_less_gifts,
        '[data-closing-standard-price]': values.discount,
        '[data-closing-preorder-price]': values.preorder,
        '[data-closing-savings]': `SAVE ${savingsLabel}`,
        '[data-closing-cta-label]': canAdd
            ? `Claim your TAO Clean system — ${savingsLabel} off →` : 'Select your finish',
    };
    Object.entries(updates).forEach(([selector, value]) => {
        closing.querySelectorAll(selector).forEach((target) => { target.textContent = value ?? ''; });
    });
    const savings = closing.querySelector('[data-closing-savings]');
    if (savings) savings.hidden = false;
    const add = closing.querySelector('[data-closing-add]');
    if (add) add.disabled = !canAdd;
    closing.querySelectorAll('[data-toggles="preorder-active"]').forEach((button) => {
        button.setAttribute('aria-pressed', String((button.dataset.toggleValue === 'true') === isPreorder));
    });
    const selectedTitles = [];
    finishStates.forEach(({ button, unavailable, selected }) => {
        button.disabled = unavailable;
        button.setAttribute('aria-pressed', String(selected));
        if (selected) selectedTitles.push(button.dataset.finishTitle);
    });
    const label = closing.querySelector('[data-closing-finish-label]');
    if (label) label.textContent = selectedTitles.join(', ');
    const summary = closing.querySelector('[data-closing-selection-summary]');
    if (summary) {
        const selections = Array.from(primary.querySelectorAll('[data-display-variant-id]'))
            .filter((row) => !row.closest('[data-gift-variant-options]'))
            .map((row) => ({
                title: row.dataset.variantLabel || row.dataset.variantTitle,
                quantity: Number(row.querySelector(SELECTORS.quantityInput)?.value) || 0,
            })).filter((selection) => selection.quantity > 0);
        summary.hidden = !isUpsert || !hasSelection
            || (state.primary_variant_quantity === 1 && Boolean(selectedId));
        summary.textContent = `${state.primary_variant_quantity} selected: ${selections
            .map(({ title, quantity }) => `${title} ×${quantity}`).join(', ')}`;
    }
}

function updateGiftVariantSelection(state, params) {
    document.querySelectorAll('[data-offer-page] [data-gift-variant-options]').forEach(root => {
        const gift = (params.gift_items || []).find(item => Number(item.id) === Number(root.dataset.giftId));
        if (!gift) return;
        const quantity = offerEngine.parseGiftQualifyingQuantity(gift, params, state.active_selections);
        offerEngine.updateGiftVariantOptions(root, quantity);
    });
}

// State key hydration
function hydrateStateKey(key) {
    const handler = STATE_HANDLERS[key];
    if (typeof handler !== 'function') return;
    return handler({
        data: stateData,
    });
}

// Commit hydration to local / window variables
function commitHydration(data, type) {
    if (!data || !type) return;
    window[type] = data;
    switch (type) {
        case 'params':
            paramsData = data;
            break;
        case 'state':
            stateData = data;
            break;
    }
}

function parseHydrationState() {
    if (!window.params || !window.state) return handleHydration();
    return {
        params: window.params,
        state: window.state,
    }
}

/* State key specific hydration utilities */

function hydrateBaseQuantitySelection() {
    const selected = document.querySelector(SELECTORS.selectedBaseQuantity);
    if (!selected) {
        // Match Liquid's lowest preset baseline without selecting a radio on the shopper's behalf.
        const quantities = Array.from(document.querySelectorAll(SELECTORS.baseQuantityInput))
            .map((input) => Number(input.value))
            .filter((quantity) => Number.isFinite(quantity) && quantity > 0);
        return quantities.length ? Math.min(...quantities) : 1;
    }

    return util.normalize.nonNegativeInteger(selected.value, { fallback: 1 });
}

function parseVariantPriceOverride(variant, discount, priceOverrides = []) {
    if (!variant || !discount || !Array.isArray(priceOverrides)) return null;
    if (!Array.isArray(discount.variant_price_overrides)) return null;

    return priceOverrides.find((override) => {
        const discountMatch = discount.variant_price_overrides.includes(override.id)
            || override.discount_ids?.includes(discount.id);

        return discountMatch && override.variants?.includes(variant.id);
    }) || null;
}

function parseCompareUnitPrice(variant, discount, priceOverrides = []) {
    if (!variant) return 0;

    const priceOverride = parseVariantPriceOverride(variant, discount, priceOverrides);
    if (priceOverride?.compare_at_price?.amount) return priceOverride.compare_at_price.amount;

    return util.compare.number.max(
        variant.compare_at_price || 0,
        variant.price || 0
    );
}

function parseDiscountedUnitPrice(variant, discount, priceOverrides = []) {
    if (!variant) return 0; // No variant, no price
    if (!discount) return variant.price; // No discount > full price

    const priceOverride = parseVariantPriceOverride(variant, discount, priceOverrides);
    if (priceOverride?.price?.amount) return priceOverride.price.amount;

    const { method, amount } = discount;
    if (!discount.variant_ids.includes(variant.id)) return variant.price; // Full price if discount not applicable

    switch (method) {
        case 'Percentage':
            return variant.price * ((100 - amount) / 100);
        case 'Fixed amount':
            return variant.price - amount;
    }
}

function checkPreorderRuleMatchesVariant(rule, variant) {
    if (!rule || !variant) return false;

    if (Array.isArray(rule.variants) && rule.variants.includes(variant.id)) return true;
    if (Array.isArray(rule.variants) && rule.variants.length > 0) return false;

    const productId = util.normalize.number(variant.product_id || variant.product?.id);
    if (!productId) return false;

    return Array.isArray(rule.products) && rule.products.includes(productId);
}

function parseUnitPreorderPrice(variant, preorderRules) {
    if (!variant) return null; // No variant, no price
    if (!preorderRules) return null; // No preorder rules > full price

    const rules = preorderRules.filter(rule => checkPreorderRuleMatchesVariant(rule, variant));
    if (!rules.length) return null; // No preorder rule for this variant > full price

    return rules.reduce((min, rule) => {
        const price = Number(rule.price_preorder?.amount);
        if (!Number.isFinite(price) || price <= 0) return min;
        return min === null ? price : Math.min(min, price);
    }, null);
}

/*
Keep uncovered colors available in stock mode. In preorder mode, native quantity
limits prevent increases while allowing a previously selected color to be removed.
*/
function updatePreorderVariantAvailability(state, variants) {
    const root = document.querySelector(SELECTORS.primaryVariantForm);
    if (!root) return;

    const variantsById = new Map(variants.map(variant => [Number(variant.id), variant]));
    root.closest(SELECTORS.offerPageRoot)?.setAttribute('data-state-preorder-unavailable',
        String(state.has_unavailable_preorder_selections));
    root.setAttribute('data-state-preorder-unavailable',
        String(state.has_unavailable_preorder_selections));

    root.querySelectorAll('[data-display-variant-id]').forEach(row => {
        if (row.closest('[data-gift-variant-options]')) return;
        const variantId = Number(row.dataset.displayVariantId);
        const unavailable = state.preorder_active
            && !(parseUnitPreorderPrice(variantsById.get(variantId), state.active_preorder_rules) > 0);
        row.setAttribute('data-state-preorder-unavailable', String(unavailable));
        const add = row.querySelector(SELECTORS.lineSelectButton);
        if (add) add.disabled = unavailable;

        const component = row.querySelector(SELECTORS.quantityComponent);
        const input = component?.querySelector(SELECTORS.quantityInput);
        if (input) {
            if (unavailable) {
                if (!preorderQuantityLimits.has(input)) {
                    preorderQuantityLimits.set(input, input.getAttribute('max'));
                }
                input.max = String(Number(input.value) + Number(input.dataset.cartQuantity || 0));
            } else if (preorderQuantityLimits.has(input)) {
                const originalMax = preorderQuantityLimits.get(input);
                if (originalMax === null) input.removeAttribute('max');
                else input.setAttribute('max', originalMax);
                preorderQuantityLimits.delete(input);
            }
            input.readOnly = unavailable;
            component.updateButtonStates?.();
        }

        const card = document.querySelector(`${SELECTORS.lightboxCard}[data-variant-id="${variantId}"]`);
        if (card) {
            card.setAttribute('data-state-preorder-unavailable', String(unavailable));
            card.querySelectorAll(`${SELECTORS.lightboxAdd}, [data-lightbox-qty-dir="up"]`)
                .forEach(button => { button.disabled = unavailable; });
        }
    });
}

// Calculates the "original" price of a preorder unit to achieve desired post-discount preorder pricing
function parseOriginalPriceFromDiscounted(preorderPrice, discount) {
    if (!preorderPrice) return null;
    if (!discount) return null;

    const { method, amount } = discount;
    switch (method) {
        case 'Percentage':
            return Math.floor(preorderPrice / ((100 - amount) / 100));
        case 'Fixed amount':
            return Math.floor(preorderPrice + amount);
    }
}

function hydrateBaseSelection(state, variant) {
    if (!state || !variant) return null;
    const { base_quantity_selection, active_discount, active_preorder_rules, active_variant_price_overrides } = state;

    return {
        quantity: base_quantity_selection,
        id: variant.id,
        pricing: parseSelectionPricing(
            variant,
            base_quantity_selection,
            active_discount,
            active_preorder_rules,
            active_variant_price_overrides
        ),
    }
}

// Extracts selected variant ids, quantities, and pricing details for each selected variant
function hydrateActiveSelections(state, variants = []) {
    const inputs = document.querySelectorAll(SELECTORS.activeQuantityInputs);
    const selections = [];
    const variantsById = new Map(
        variants.map((variant) => [util.normalize.number(variant.id), variant])
    );

    inputs.forEach((input) => {
        const variantWrapper = input.closest('[data-variant-id]');
        const variantId = variantWrapper
            ? util.normalize.number(variantWrapper.getAttribute('data-variant-id'))
            : null;
        if (!variantId) return;

        const quantity = util.normalize.nonNegativeInteger(input.value, { fallback: 0 });
        if (quantity <= 0) {
            if (quantity < 0) input.value = '0';
            return;
        };

        const selection = {
            id: variantId,
            quantity,
        };

        const variant = variantsById.get(variantId);

        if (variant) {
            selection.pricing = parseSelectionPricing(
                variant,
                quantity,
                state.active_discount,
                state.active_preorder_rules,
                state.active_variant_price_overrides
            );
        }

        selections.push(selection);
    });

    return selections;
}

function parseSelectionPricing(variant, quantity, discount, preorderRules, priceOverrides = []) {
    const compareUnit = parseCompareUnitPrice(variant, discount, priceOverrides);
    const offerUnit = parseDiscountedUnitPrice(variant, discount, priceOverrides);
    const variantOverride = priceOverrides.find(override => override.variants.includes(variant.id)) || null;
    const variantOverrideOriginal = variantOverride ? parseOriginalPriceFromDiscounted(variantOverride.price.amount, discount)  : null;
    const preorderUnit = parseUnitPreorderPrice(variant, preorderRules);
    const preorderUnitOriginal = preorderUnit
        ? parseOriginalPriceFromDiscounted(preorderUnit, discount)
        : variant.price;

    const preorderDiscountRate = preorderUnitOriginal ? offerEngine.parseActiveDiscountRate(preorderUnit, preorderUnitOriginal) : null;

    return {
        compare: compareUnit * quantity,
        compare_unit: compareUnit,
        ...(variantOverrideOriginal ? { compare_override: variantOverrideOriginal } : {}),
        offer: (offerUnit || 0) * quantity,
        offer_unit: offerUnit || 0,
        preorder: preorderUnit != null ? preorderUnit * quantity : null,
        preorder_unit: preorderUnit ?? null,
        preorder_original_unit: preorderUnitOriginal ?? null,
        preorder_discount_rate: preorderDiscountRate ?? null,
        msrp: variant.price,
    };
}

function hydrateVariantQuantities(type) {
    const selector = type === 'primary' ? SELECTORS.primaryVariantForm : SELECTORS.upsellVariantForm;
    const wrapper = document.querySelector(selector);
    if (!wrapper) return null;

    const quantities = Array.from(wrapper.querySelectorAll(SELECTORS.quantityInput)).filter(input => !input.closest('[data-gift-variant-options]')).map((input) => util.normalize.nonNegativeInteger(input.value, { fallback: 0 }));
    return quantities.reduce((sum, number) => sum + Number(number), 0);
}


/* ———————————————————————————————————————— */
/* hyrdation parsers */
/* ———————————————————————————————————————— */

// Find the discount with the highest eligibility_minimum_quantity >= baseline_quantity
function hydrateActiveDiscount(data) {
    const { state, params } = data;
    const discounts = params?.discounts || [];
    if (!discounts.length) return {};

    let matchedDiscount = null;
    let maxMinQty = -Infinity;

    for (const discount of discounts) {
        const minQty = Number(discount.eligibility_minimum_quantity) || 0;
        if (state.baseline_quantity >= minQty && minQty > maxMinQty) {
            matchedDiscount = discount;
            maxMinQty = minQty;
        }
    }

    return matchedDiscount || {};
}

// Find preorder rules that are applicable to the active discount
function hydrateActivePreorderRules(data) {
    const { discount, params } = data;
    const preorderRules = params?.preorder_rules || [];
    if (!discount?.preorder_rules?.length) return [];
    return parseValidPreorderRules(preorderRules)
        .filter(rule => discount.preorder_rules.includes(rule.id)) || [];
}

/*
Preorder delay is order metadata, so an absent or undersized value must not be
coerced into a valid zero-day shipping promise.
*/
function parsePreorderDelay(value) {
    const delay = Number(value);
    return Number.isFinite(delay) && delay >= MIN_PREORDER_DELAY_DAYS ? delay : null;
}

function parseValidPreorderRules(rules = []) {
    return rules.filter(rule => (
        rule?.id && parsePreorderDelay(rule.delay_days) !== null
    ));
}

function parsePreorderRuleState(rules = []) {
    const validRules = parseValidPreorderRules(rules);
    if (!validRules.length) return null;

    return {
        delay: validRules.reduce((max, rule) => (
            Math.max(max, parsePreorderDelay(rule.delay_days))
        ), MIN_PREORDER_DELAY_DAYS),
        ruleIds: validRules.map(rule => rule.id).filter(Boolean),
    };
}

function parseApplicablePreorderRules(rules = [], selections = []) {
    if (!rules.length || !selections.length) return [];

    const selectedVariantIds = new Set(
        selections
            .map(item => Number(item?.id || item?.variant_id))
            .filter(Number.isFinite)
    );

    return rules.filter(rule => (
        Array.isArray(rule.variants)
        && rule.variants.some(variantId => selectedVariantIds.has(Number(variantId)))
    ));
}

function hydrateActivePriceOverrides(data) {
    const { discount, params } = data;
    const priceOverrides = params?.variant_price_overrides || [];
    if (!discount?.variant_price_overrides?.length) return [];

    return priceOverrides.filter(override => discount.variant_price_overrides.includes(override.id)) || [];
}

function hydratePreorderActive() {
    return document.querySelector(SELECTORS.preorderActive) instanceof HTMLElement ? true : false;
}

// Find currently applicable gift items
function parseApplicableGiftItems(data) {
    const { quantity, giftItems = [], products = [] } = data;
    const variantsById = new Map();

    products.forEach((product) => {
        (product.variants || []).forEach((variant) => {
            variantsById.set(variant.id, variant);
        });
    });

    const items = giftItems.filter((item) => quantity >= item.qualifier_threshold);

    items.forEach((item) => {
        if (item.compare_at_price) return;

        item.compare_at_price = { amount: 0 };
        (item.variant_ids || []).forEach((variantId) => {
            const variant = variantsById.get(variantId);
            const variantPrice = variant
                ? util.compare.number.max(variant.compare_at_price || 0, variant.price || 0)
                : 0;
            if (variantPrice > item.compare_at_price.amount) {
                item.compare_at_price.amount = variantPrice;
            }
        });
    });

    return items;
}

function parsePriceStates(state, variants = []) {
    const {
        base_applicable_gifts = [],
        applicable_gifts = [],
        active_selections = [],
        base_selection_highest_value = null,
        base_selection_lowest_price = null,
        base_selection_lowest_preorder = null,
        base_quantity_selection = 0,
        baseline_quantity = 0
    } = state || {};

    // BASE CONTEXT
    const baseHighValuePricing = parseSelectionPriceValues(
        base_selection_highest_value ? [base_selection_highest_value] : []
    );
    const baseLowPricePricing = parseSelectionPriceValues(
        base_selection_lowest_price ? [base_selection_lowest_price] : []
    );
    const basePreorderPricing = parseSelectionPriceValues(
        base_selection_lowest_preorder ? [base_selection_lowest_preorder] : []
    );

    const baseGiftMsrp = parseGiftMsrp(base_applicable_gifts);
    const baseMsrp = baseHighValuePricing.compare + baseGiftMsrp;
    const baseMsrpLessGifts = baseHighValuePricing.compare;

    const baseSavingsAmount = baseMsrp - baseLowPricePricing.offer;
    const baseSavingsAmountPreorder = baseMsrp - basePreorderPricing.preorder;

    const baseSavingsAmountLessGifts = baseMsrpLessGifts - baseLowPricePricing.offer;
    const baseSavingsAmountPreorderLessGifts = baseMsrpLessGifts - basePreorderPricing.preorder;

    // Tiles template price row: stackable gifts count once per entitled quantity.
    const baseMsrpStacked = baseMsrpLessGifts + parseGiftMsrpStacked(base_applicable_gifts, base_quantity_selection);

    // SELECTION CONTEXT
    const selectionPriceValues = parseSelectionPriceValues(active_selections);
    const selectionGiftMsrp = parseGiftMsrp(applicable_gifts);
    const selectionMsrp = selectionPriceValues.compare + selectionGiftMsrp;
    const selectionMsrpLessGifts = selectionPriceValues.compare;

    const selectionSavingsAmount = selectionMsrp - selectionPriceValues.offer;
    const selectionSavingsAmountPreorder = selectionMsrp - selectionPriceValues.preorder;

    const selectionSavingsAmountLessGifts = selectionMsrpLessGifts - selectionPriceValues.offer;
    const selectionSavingsAmountPreorderLessGifts = selectionMsrpLessGifts - selectionPriceValues.preorder;

    // Tiles template pop-up price row: stackable gifts count once per entitled quantity, at the
    // count the pop-up's gift badges show (the tier or the picks, whichever is higher).
    const selectionMsrpStacked = selectionMsrpLessGifts + parseGiftMsrpStacked(applicable_gifts, baseline_quantity);

    return {
        base: {
            compare: baseMsrp,
            compare_less_gifts: baseMsrpLessGifts,
            compare_stacked: baseMsrpStacked,
            compare_unit: baseHighValuePricing.compare_unit,
            preorder: basePreorderPricing.preorder,
            preorder_unit: basePreorderPricing.preorder_unit,
            discount: baseLowPricePricing.offer,
            discount_unit: baseLowPricePricing.offer_unit,
            savings: {
                amount: baseSavingsAmount,
                amount_less_gifts: baseSavingsAmountLessGifts,
                amount_stacked: baseMsrpStacked - baseLowPricePricing.offer,
                amount_preorder: baseSavingsAmountPreorder,
                amount_preorder_less_gifts: baseSavingsAmountPreorderLessGifts,
                percent: parseSavingsPercent(baseMsrp, baseSavingsAmount),
                percent_less_gifts: parseSavingsPercent(baseMsrpLessGifts, baseSavingsAmountLessGifts),
                percent_preorder: parseSavingsPercent(baseMsrp, baseSavingsAmountPreorder),
                percent_preorder_less_gifts: parseSavingsPercent(baseMsrpLessGifts, baseSavingsAmountPreorderLessGifts),
            },
        },
        selections: {
            compare: selectionMsrp,
            compare_less_gifts: selectionMsrpLessGifts,
            compare_stacked: selectionMsrpStacked,
            preorder: selectionPriceValues.preorder,
            preorder_unit: selectionPriceValues.preorder_unit,
            discount: selectionPriceValues.offer,
            discount_unit: selectionPriceValues.offer_unit,
            savings: {
                amount: selectionSavingsAmount,
                amount_less_gifts: selectionSavingsAmountLessGifts,
                amount_stacked: selectionMsrpStacked - selectionPriceValues.offer,
                amount_preorder: selectionSavingsAmountPreorder,
                amount_preorder_less_gifts: selectionSavingsAmountPreorderLessGifts,
                percent: parseSavingsPercent(selectionMsrp, selectionSavingsAmount),
                percent_less_gifts: parseSavingsPercent(selectionMsrpLessGifts, selectionSavingsAmountLessGifts),
                percent_preorder: parseSavingsPercent(selectionMsrp, selectionSavingsAmountPreorder),
                percent_preorder_less_gifts: parseSavingsPercent(selectionMsrpLessGifts, selectionSavingsAmountPreorderLessGifts),
            },
        },
    };
}

function parseSelectionPriceValues(items = []) {
    const output = {
        compare: 0,
        compare_unit: 0,
        offer: 0,
        offer_unit: null,
        preorder: 0,
        preorder_unit: null,
    };

    items.forEach((item) => {
        const pricing = item?.pricing || {};

        const compare = Number(pricing.compare) || 0;
        const compareUnit = Number(pricing.compare_unit) || 0;
        const offer = Number(pricing.offer) || 0;
        const offerUnitRaw = pricing.offer_unit;
        const preorder = Number(pricing.preorder) || 0;
        const preorderUnitRaw = pricing.preorder_unit;

        const offerUnit = offerUnitRaw == null ? null : Number(offerUnitRaw);
        const preorderUnit = preorderUnitRaw == null ? null : Number(preorderUnitRaw);

        output.compare += compare;
        output.offer += offer;
        output.preorder += preorder;

        if (compareUnit > output.compare_unit) {
            output.compare_unit = compareUnit;
        }

        if (Number.isFinite(offerUnit) && (output.offer_unit == null || offerUnit < output.offer_unit)) {
            output.offer_unit = offerUnit;
        }

        if (Number.isFinite(preorderUnit) && (output.preorder_unit == null || preorderUnit < output.preorder_unit)) {
            output.preorder_unit = preorderUnit;
        }
    });

    if (output.offer_unit == null) output.offer_unit = 0;
    if (output.preorder_unit == null) output.preorder_unit = 0;

    return output;
}

function parseSelectionPrice(line, key) {
    if (!key || !line) return 0;
    const msrp = items.reduce((sum, line) => {
        return sum + (line[key] || 0);
    }, 0);
}

function parseGiftMsrp(gifts = []) {
    return gifts.reduce((sum, gift) => {
        const amount = Number(gift?.compare_at_price?.amount) || 0;
        return sum + amount;
    }, 0);
}

// Like parseGiftMsrp, but a stackable gift counts once per entitled quantity.
function parseGiftMsrpStacked(gifts = [], quantity = 0) {
    return gifts.reduce((sum, gift) => {
        const amount = Number(gift?.compare_at_price?.amount) || 0;
        const giftQuantity = offerEngine.parseGiftItemQuantity(quantity, {
            allow_multiple: gift?.allow_multiple === true,
            qualifier_threshold: Math.max(Number(gift?.qualifier_threshold) || 1, 1),
            additional_qualifier_threshold: gift?.additional_qualifier_threshold,
            quantity: gift?.quantity,
            additional_quantity: gift?.additional_quantity,
            max_allowed: Number(gift?.max_allowed) || 0,
        });
        return sum + amount * Math.max(giftQuantity, 1);
    }, 0);
}

function extractHighestValueVariant(variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;

    return variants.reduce((maxVariant, candidate) => {
        // Fallback to 0 if neither price is available
        const maxValue = Math.max(
            maxVariant ? (maxVariant.compare_at_price || 0) : 0,
            maxVariant ? (maxVariant.price || 0) : 0
        );
        const candidateValue = Math.max(candidate.compare_at_price || 0, candidate.price || 0);

        return candidateValue > maxValue ? candidate : maxVariant;
    }, null);
}

function extractLowestPriceVariant(variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;
    return variants.reduce((minVariant, candidate) => {
        if (!minVariant) return candidate;
        return (candidate.price < minVariant.price) ? candidate : minVariant;
    }, null);
}

function extractHighestCompareVariant(state, variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;

    return variants.reduce((maxVariant, candidate) => {
        if (!maxVariant) return candidate;

        const maxValue = parseCompareUnitPrice(
            maxVariant,
            state.active_discount,
            state.active_variant_price_overrides
        );
        const candidateValue = parseCompareUnitPrice(
            candidate,
            state.active_discount,
            state.active_variant_price_overrides
        );

        return candidateValue > maxValue ? candidate : maxVariant;
    }, null);
}

function extractLowestOfferVariant(state, variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;

    return variants.reduce((minVariant, candidate) => {
        if (!minVariant) return candidate;

        const minValue = parseDiscountedUnitPrice(
            minVariant,
            state.active_discount,
            state.active_variant_price_overrides
        );
        const candidateValue = parseDiscountedUnitPrice(
            candidate,
            state.active_discount,
            state.active_variant_price_overrides
        );

        return candidateValue < minValue ? candidate : minVariant;
    }, null);
}

function extractLowestPreorderVariant(state, variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;
    if (!Array.isArray(state.active_preorder_rules) || state.active_preorder_rules.length === 0) return null;

    return variants.reduce((minVariant, candidate) => {
        const candidateValue = parseUnitPreorderPrice(candidate, state.active_preorder_rules);
        if (candidateValue == null) return minVariant;
        if (!minVariant) return candidate;

        const minValue = parseUnitPreorderPrice(minVariant, state.active_preorder_rules);
        if (minValue == null) return candidate;

        return candidateValue < minValue ? candidate : minVariant;
    }, null);
}

function parseSavingsPercent(originalPrice, savingsAmount) {
    if (!originalPrice || originalPrice <= 0) return 0;
    if (!savingsAmount || savingsAmount <= 0) return 0;

    return Math.round((savingsAmount / originalPrice) * 100);
}

/* ———————————————————————————————————————— */
/* event handlers */
/* ———————————————————————————————————————— */

/* document-level */

/*
Close before bfcache takes its snapshot and again on history restoration as a fallback.
Keep preparation detached while closing restores focus, then re-arm it on history
restoration so the next interaction prepares the offer cart like an initial visit.
*/
function handlePageNavigation(event) {
    const isHistoryRestore = event.type === 'pageshow' && (
        event.persisted
        || window.performance.getEntriesByType('navigation')[0]?.type === 'back_forward'
    );
    if (event.type !== 'pagehide' && !isHistoryRestore) return;

    destroyFirstInteractionHandlers();
    window.clearTimeout(firstInteractionPrepTimer);
    firstInteractionPrepTimer = null;
    hasPreparedCart = false;

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.closeDialog === 'function') {
        cartDrawer.removeEventListener('dialog:close', resetFirstInteractionPrep);
        void cartDrawer.closeDialog({ immediate: true });
    }

    if (isHistoryRestore) resetFirstInteractionPrep();
}

function handleFirstInteractionPrep(event) {
    destroyFirstInteractionHandlers();

    if (checkInteractionNavigatesAway(event)) return;
    if (window.hasTriggeredFirstInteraction) return;
    window.hasTriggeredFirstInteraction = true;

    firstInteractionPrepTimer = window.setTimeout(() => {
        firstInteractionPrepTimer = null;
        void ensurePreparedOfferCart({ reason: 'first-interaction' });
    }, 0);
}

function resetFirstInteractionPrep() {
    hasPreparedCart = false;
    window.hasTriggeredFirstInteraction = false;
    destroyFirstInteractionHandlers();
    initFirstInteractionHandlers();
}

function checkInteractionNavigatesAway(event) {
    if (event?.type === 'focusin') return false;
    if (event?.type === 'keydown' && event.key !== 'Enter') return false;

    const target = event?.target;
    if (!(target instanceof Element)) return false;

    const anchor = target.closest('a[href]');
    if (!(anchor instanceof HTMLAnchorElement)) return false;
    if (anchor.hasAttribute('download')) return true;
    if (anchor.target && anchor.target !== '_self') return true;

    const rawHref = anchor.getAttribute('href') || '';
    if (!rawHref || rawHref.startsWith('#')) return false;

    try {
        const url = new URL(anchor.href, window.location.href);
        return url.origin !== window.location.origin
            || url.pathname !== window.location.pathname
            || url.search !== window.location.search;
    } catch (error) {
        void error;
        return false;
    }
}

/* Keep the shopper's inline minimum separate from the automatically checked tier. */
function updateInlineQuantityPreset() {
    const root = document.querySelector('[data-inline-selection]');
    if (!root) return;
    const inputs = Array.from(root.querySelectorAll(SELECTORS.baseQuantityInput))
        .filter((input) => Number(input.value) > 0)
        .sort((a, b) => Number(a.value) - Number(b.value));
    if (!inputs.length) return;

    const quantity = hydrateVariantQuantities('primary');
    let baseline = inlineQuantityBaselines.get(root);
    if (baseline === undefined) {
        const checked = inputs.find((input) => input.checked);
        if (checked) baseline = Number(checked.value);
        else if (quantity > 0) {
            const eligible = inputs.filter((input) => Number(input.value) <= quantity);
            baseline = Number((eligible.at(-1) || inputs[0]).value);
        } else return;
        inlineQuantityBaselines.set(root, baseline);
    }

    const eligible = inputs.filter((input) => Number(input.value) <= quantity);
    const activeQuantity = Math.max(baseline, Number(eligible.at(-1)?.value || 0));
    inputs.forEach((input) => { input.checked = Number(input.value) === activeQuantity; });
}

function handleDelegatedDocumentEvent(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    // The engine owns upsell events; keep primary-selection hydration separate.
    if (target.closest('[data-offer-upsell], [data-gift-variant-options]')) return;

    const inlineRoot = target.closest('[data-inline-selection]');
    if (inlineRoot && target.matches(SELECTORS.baseQuantityInput)
        && (event.type === 'click' || event.type === 'change')) {
        inlineQuantityBaselines.set(inlineRoot, Number(target.value));
        handleBaseQuantityChange(event, target, handleHydration());
        return;
    }

    const handlers = EVENT_HANDLERS[event.type];
    if (!(handlers instanceof Map)) return;

    for (const [selector, config] of handlers.entries()) {
        const el = target.closest(selector);
        if (!el) continue;

        const handler = config?.handler;
        if (typeof handler !== 'function') break;

        const hydrate = config?.hydrate || false;
        const prehydrate = hydrate && !config?.hydrateAfter || false;
        const data = prehydrate ? handleHydration() : null;

        handler(event, el, data);
        if (hydrate && config?.hydrateAfter) {
            const updatedData = handleHydration();
            if (el.matches(SELECTORS.preorderToggle)) {
                handleBaseQuantityChange(event, el, updatedData);
            }
        }
        break;
    }
}

/*
Page quantity selection change
*/
function handleBaseQuantityChange(event, el, data) {
    void (event, el);

    updateSelectionForm({ quantity: data.state.primary_variant_quantity, selected_minimum: data.state.base_quantity_selection, discount_id: data.state.active_discount.id });
    updateOfferSummaries(data.state.preorder_active, data.state.base_quantity_selection, data.state.price_display, data.state.baseline_quantity, data.state.primary_variant_quantity);
    updateSelectionTotals(data.state.price_display, data.state.primary_variant_quantity);
    updatePageCtas(data.state.price_display, data.state.base_quantity_selection);
    updateDiscountDisplay(data.state);
    updateAddButtonState(data.state.base_quantity_selection, data.state.primary_variant_quantity,
        data.state.has_unavailable_preorder_selections);
    updateGiftDisplayState(data.state);
}

function updateSelectionForm(attrs = {}) {
    const wrapper = document.querySelector(SELECTORS.variantSelection);
    if (!wrapper) return;

    if (attrs.quantity) wrapper.setAttribute(ATTR.selectedQuantity, String(attrs.quantity));
    if (attrs.selected_minimum) wrapper.setAttribute(ATTR.selectedMinimum, String(attrs.selected_minimum));
    if (attrs.discount_id) wrapper.setAttribute(ATTR.activeDiscountId, attrs.discount_id);
    if (attrs.preorder) wrapper.setAttribute(ATTR.preorderActive, attrs.preorder);
}

function updateOfferSummaries(preorderActive, selections, pricing, baseQuantity, selectedQuantity) {
    const pageSummaries = document.querySelectorAll(SELECTORS.summaryElement);

    pageSummaries.forEach((el) => {
        updateSummaryContent(preorderActive, pricing, el, baseQuantity, selectedQuantity)
    });
}

// Tiles modal: the picked count in the header and the CTA pill's totals (the struck
// value excludes gifts). Before the first pick the pill shows one brush at the chosen
// tier. Only the tiles template renders these targets.
function updateSelectionTotals(pricing, selectedQuantity) {
    const hasPicks = selectedQuantity > 0;
    const CONTENT_UPDATES = {
        [SELECTORS.selectedQuantityDisplay]: selectedQuantity || 0,
        [SELECTORS.selectionPriceDisplay]: hasPicks ? pricing?.selections?.discount : pricing?.base?.discount_unit,
        [SELECTORS.selectionValueDisplay]: hasPicks ? pricing?.selections?.compare_less_gifts : pricing?.base?.compare_unit,
    };

    Object.entries(CONTENT_UPDATES).forEach(([selector, value]) => {
        document.querySelectorAll(selector).forEach((el) => {
            el.textContent = value ?? '';
        });
    });
}

function updatePageCtas(pricing, baseQuantity) {
    const pageCtas = document.querySelectorAll(SELECTORS.ctaButtons);
    pageCtas.forEach((el) => {
        updateCtaContent(pricing, el, 'base');
        if (el.matches('[data-action="modal:open"][data-modal-target="offer-variant-selection"]')) {
            el.disabled = !(baseQuantity > 0);
        }
    });
}

function updateCtaContent(values, cta) {
    const wrapper = cta.querySelector(SELECTORS.ctaTextWrapper);
    if (!wrapper) return;

    const defaultTextString = cta.getAttribute(ATTR.defaultTextString);
    if (!defaultTextString) return;

    const vals = values?.base;
    if (!vals) return;

    const preorderContext = cta.dataset.toggles === 'preorder-active' && cta.dataset.toggleValue === 'true';

    const replacements = {
        '[price]': preorderContext ? vals.preorder : vals.discount,
        '[unit_price]': preorderContext ? vals.preorder_unit : vals.discount_unit,
        '[savings_percentage]': preorderContext ? vals.savings?.percent_preorder : vals.savings?.percent,
        '[savings_percentage_less_gifts]': preorderContext ? vals.savings?.percent_preorder_less_gifts : vals.savings?.percent_less_gifts,
        '[savings_amount]': preorderContext ? vals.savings?.amount_preorder : vals.savings?.amount,
        '[savings_amount_less_gifts]': preorderContext ? vals.savings?.amount_preorder_less_gifts : vals.savings?.amount_less_gifts,
    };

    let nextText = defaultTextString;

    Object.entries(replacements).forEach(([token, rawValue]) => {
        if (!nextText.includes(token)) return;

        const safeValue = rawValue == null || Number.isNaN(rawValue) ? 0 : rawValue;
        nextText = nextText.replaceAll(token, safeValue);
    });

    wrapper.textContent = nextText;
}

function updateDiscountDisplay(state) {
    if (!state) return;
    
    const CONTENT_UPDATES = {
        [SELECTORS.discountSavingsAmount]: state.active_discount.display_amount.amount,
        [SELECTORS.offerActiveQuantity]: state.baseline_quantity,
        [SELECTORS.baseQuantityDisplay]: state.base_quantity_selection,
    }

    const DISPLAY_UPDATES = {
        [SELECTORS.offerActivePluralization]: state.baseline_quantity === 1,
        [SELECTORS.baseQuantityPluralization]: state.base_quantity_selection === 1,
    }

    Object.entries(CONTENT_UPDATES).forEach(([selector, value]) => {
        Array.from(document.querySelectorAll(selector)).forEach((el) => {
            if (el instanceof HTMLElement) el.textContent = value;
        });
    });
    Object.entries(DISPLAY_UPDATES).forEach(([selector, value]) => {
        Array.from(document.querySelectorAll(selector)).forEach((el) => {
            if (el instanceof HTMLElement) el.classList.toggle('hidden', value);
        });
    });
}

function updateAddButtonState(baseQuantity, selectedQuantity, hasUnavailablePreorderSelections = false) {
    if (inlineStickyFooterSelectionSync) inlineStickyFooterSelectionSync(selectedQuantity);
    const addButton = document.querySelector(SELECTORS.addToCartButton);
    if (!addButton) return;
    addButton.disabled = selectedQuantity < baseQuantity || hasUnavailablePreorderSelections;
    updateInlineCtaLabel(addButton, baseQuantity, selectedQuantity);
}

// Inline selection CTA label — two states: the "Select N Toothbrush(es)"
// prompt until the required quantity is selected (N = the offer minimum), and
// the selected-state text ("Reserve Now") once the add button unlocks.
// No-ops on modal templates, whose add button has no label element.
function updateInlineCtaLabel(addButton, baseQuantity, selectedQuantity) {
    const label = addButton.querySelector(SELECTORS.inlineCtaLabel);
    if (!label) return;

    if (selectedQuantity >= baseQuantity && addButton.dataset.labelSelected) {
        label.textContent = addButton.dataset.labelSelected;
        return;
    }

    const count = Math.max(selectedQuantity, baseQuantity, 1);
    const template = count === 1 ? addButton.dataset.labelSingular : addButton.dataset.labelPlural;
    if (!template) return;
    label.textContent = template.replaceAll('[quantity]', count);
}

function extractCtaTextVariable(value) {
    const match = value.match(/\[(.*?)\]/);
    return match ? match[1] : null;
}

function captureSummaryElements(summary) {
    return {
        original: summary.querySelector(SELECTORS.summaryValue),
        price: summary.querySelector(SELECTORS.summaryPrice),
        preorder_price: summary.querySelector(SELECTORS.summaryPreorderPrice),
        savings: summary.querySelector(SELECTORS.summarySavings),
    };
}

function updateSummaryContent(preorderActive, values, summary, baseQuantity, selectedQuantity) {
    if (!summary || !values) return;

    const type = summary.dataset.elementPosition || 'page';
    const isInlineSelection = summary.dataset.displayContext === 'selections';
    if (window.params.discounts.length < 2 && type === 'page' && !isInlineSelection) return;
    const key = type === 'page' && !isInlineSelection ? 'base' : 'selections';
    
    const { original, price, preorder_price, savings } = captureSummaryElements(summary);
    // Tiles template: gift value counts once per stacked gift, on the page's price row and in the
    // pop-up's, so both show the same savings.
    const isStacked = values[key].compare_stacked != null && Boolean(summary.closest('[data-tiles-styling]'));
    if (original) original.textContent = isStacked ? values[key].compare_stacked : values[key].compare;
    if (price) price.textContent = values[key].discount;
    if (preorder_price) preorder_price.textContent = values[key].preorder;
    if (savings) savings.textContent = isStacked ? values[key].savings.amount_stacked
        : preorderActive && (type === 'modal' || isInlineSelection)
            ? values[key].savings.amount_preorder : values[key].savings.amount;

    if (type === 'modal' || isInlineSelection) {
        summary.classList.toggle('hidden', selectedQuantity < baseQuantity || (isInlineSelection && selectedQuantity === 0));
    }
    if (isInlineSelection) {
        // Inline summaries have no modal selection-form ancestor to control these displays.
        if (price) price.hidden = Boolean(preorderActive);
        if (preorder_price) preorder_price.hidden = !preorderActive;
        const delimiter = summary.querySelector('[data-content="preorder-price-delimiter"]');
        const upTo = summary.querySelector('[data-content="offer-saving-up-to"]');
        if (delimiter) delimiter.hidden = true;
        if (upTo) upTo.hidden = true;
    }
}

function updateGiftDisplayState(state) {
    if (!state) return;
    
    const giftDisplays = document.querySelectorAll(SELECTORS.giftDisplay);
    giftDisplays.forEach((el) => {
        updateGiftDisplayContent(state, el);
    });
}

function updateGiftDisplayContent(state, el) {
    if (!state || !el) return;
    const location = el.dataset.location || 'page';
    const { base_quantity_selection, primary_variant_quantity, base_applicable_gifts, applicable_gifts } = state;
    const quantity = location === 'page' && el.dataset.displayContext !== 'selections'
        ? base_quantity_selection 
        : primary_variant_quantity >= base_quantity_selection
            ? primary_variant_quantity
            : base_quantity_selection;

    const elements = el.querySelectorAll(SELECTORS.giftDisplayItem);
    const giftSetLabel = el.querySelector('[data-content="gift-set-count"]');
    let hasMatchingGiftSet = giftSetLabel !== null && el.dataset.giftSetAvailable === 'true';
    let commonThreshold = null;
    let giftSetQuantity = null;
    let unlockedCount = 0
    elements.forEach((el) => {
        const threshold = util.normalize.number(el.dataset.giftThreshold);
        const isUnlocked = quantity >= threshold;
        el.classList.toggle('gift--inactive', !isUnlocked);
        const deltaLabel = el.querySelector('[data-content="gift-threshold-delta"]');
        if (deltaLabel) deltaLabel.textContent = String(Math.max(threshold - quantity, 0));
        const quantityBadge = el.querySelector('[data-content="gift-item-quantity"]');
        if (quantityBadge || giftSetLabel) {
            const giftQuantity = isUnlocked ? offerEngine.parseGiftItemQuantity(quantity, {
                allow_multiple: el.dataset.giftStackable === 'true',
                qualifier_threshold: Math.max(threshold, 1),
                additional_qualifier_threshold: el.dataset.giftAdditionalThreshold,
                quantity: el.dataset.giftInitialQuantity,
                additional_quantity: el.dataset.giftAdditionalQuantity,
                max_allowed: util.normalize.number(el.dataset.giftMaxAllowed),
            }) : 0;
            if (quantityBadge) {
                quantityBadge.textContent = `${quantityBadge.dataset.quantityPrefix || 'x'}${giftQuantity}`;
                quantityBadge.setAttribute('aria-label', `${giftQuantity} gifts`);
                quantityBadge.hidden = giftQuantity <= 1;
            }
            if (giftSetLabel) {
                const normalizedThreshold = Math.max(threshold, 1);
                if (commonThreshold === null) commonThreshold = normalizedThreshold;
                if (commonThreshold !== normalizedThreshold) hasMatchingGiftSet = false;
                if (el.dataset.giftHasVariants === 'true') {
                    if (el.dataset.giftStackable !== 'true' || giftQuantity < 1) {
                        hasMatchingGiftSet = false;
                    }
                    if (giftSetQuantity === null) giftSetQuantity = giftQuantity;
                    if (giftSetQuantity !== giftQuantity) hasMatchingGiftSet = false;
                }
            }
        }
        if (isUnlocked) unlockedCount++;
    });

    updateGiftDescriptionContent(el, quantity);

    const unlockedLabel = el.querySelector(SELECTORS.giftUnlockedPill);
    if (!unlockedLabel) return;
    unlockedLabel.querySelector(SELECTORS.giftUnlockedNumber).textContent = unlockedCount;

    if (giftSetLabel) {
        const showGiftSets = hasMatchingGiftSet && giftSetQuantity > 0;
        giftSetLabel.querySelector('[data-content="gift-set-text"]').textContent = `${giftSetQuantity || 0}x FREE GIFT SET`;
        giftSetLabel.hidden = !showGiftSets;
        unlockedLabel.querySelector('[data-content="gift-unlocked-label"]').hidden = showGiftSets;
    }

    unlockedLabel.classList.toggle('max--unlocked', unlockedCount === elements.length);
}

function updateGiftDescriptionContent(giftDisplay, quantity) {
    giftDisplay.querySelectorAll('[data-gift-description-rules]').forEach((description) => {
        const gifts = JSON.parse(description.dataset.giftDescriptionRules);
        const physicalGifts = gifts.filter((gift) => gift.has_variants);
        const setQuantities = physicalGifts.map((gift) => (
            gift.available && gift.allow_multiple && quantity >= gift.qualifier_threshold
                ? offerEngine.parseGiftItemQuantity(quantity, gift)
                : 0
        ));
        const setQuantity = setQuantities.length && setQuantities[0] > 0
            && setQuantities.every((count) => count === setQuantities[0])
            ? setQuantities[0] : 0;
        const values = {
            quantity,
            gift_set_quantity: setQuantity,
            gift_item_count: gifts.filter((gift) => gift.available).length,
            unlocked_gift_count: gifts.filter((gift) => (
                gift.available && quantity >= gift.qualifier_threshold
            )).length,
        };
        description.querySelectorAll('[data-gift-description-token]').forEach((token) => {
            const value = values[token.dataset.giftDescriptionToken];
            if (value !== undefined) token.textContent = String(value);
        });
    });
}

/*
Modal add button click
*/
function handleLineSelect(event, el, data) {
    void (event, data);
    if (!el) return;

    const group = captureQuantityGroup(el);
    if (!group ||Object.keys(group).length === 0) return;

    group.elements.input.value = '1';
    group.elements.input.dispatchEvent(new Event('input', { bubbles: true }));

    // The dispatch is synchronous, so the sticky footer's attributes reflect
    // this selection by the time the reveal measures against them.
    revealLineAboveStickyFooter(el);
}

/*
Selecting a low row can slide the sticky footer up over that very row (see
initInlineStickyFooter) — reveal the row the shopper just touched. Two scroll
contexts: the capped list first brings the row fully inside its own viewport
(the peek row is half-clipped by design, and the "scroll for more" bar
overlays the list's bottom edge, so clear that too), then the page scrolls
the row past the pinned footer. The page delta is computed from the row's
predicted post-list-scroll position — both smooth scrolls run concurrently,
so mid-animation rects can't be trusted. The footer's rect can't be either
while its rise animation plays; offsetHeight is transform-immune, and the
pinned footer's border-box bottom sits exactly on the fold.
*/
const STICKY_FOOTER_REVEAL_GAP = 12;

function revealLineAboveStickyFooter(el) {
    const footer = document.querySelector('.offer-page--block.inline-sticky-footer');
    if (!footer) return;
    if (!footer.hasAttribute('data-footer-shown') || !footer.hasAttribute('data-footer-pinned')) return;

    const line = el.closest('.variant-line') || el;
    const lineRect = line.getBoundingClientRect();

    let listShift = 0;
    const list = line.closest(SELECTORS.inlineSelectionList);
    if (list && list.scrollHeight > list.clientHeight + 1) {
        const listRect = list.getBoundingClientRect();
        const wrapper = list.closest('.inline-variant-selection');
        const bar = wrapper && wrapper.hasAttribute('data-list-capped')
            ? wrapper.querySelector('.inline-variant-selection--more')
            : null;
        const visibleListBottom = listRect.bottom - (bar ? bar.offsetHeight : 0);
        const clippedBelow = lineRect.bottom - visibleListBottom;
        const clippedAbove = listRect.top - lineRect.top;
        if (clippedBelow > 0) {
            listShift = Math.min(clippedBelow, list.scrollHeight - list.clientHeight - list.scrollTop);
        } else if (clippedAbove > 0) {
            listShift = -Math.min(clippedAbove, list.scrollTop);
        }
        if (listShift !== 0) list.scrollBy({ top: listShift, behavior: 'smooth' });
    }

    const footerTop = viewportFold() - footer.offsetHeight;
    const pageShift = (lineRect.bottom - listShift) - (footerTop - STICKY_FOOTER_REVEAL_GAP);
    if (pageShift > 0) window.scrollBy({ top: pageShift, behavior: 'smooth' });
}

function captureQuantityGroup(el) {
    const group = el.closest(SELECTORS.quantityGroup);
    if (!group) return null;
    
    return {
        wrapper: group,
        elements: {
            activateButton: group.querySelector(SELECTORS.plusButton),
            input: group.querySelector(SELECTORS.quantityInput),
            lineSelectButton: group.querySelector(SELECTORS.lineSelectButton),
            minusButton: group.querySelector(SELECTORS.minusButton),
            quantityComponent: group.querySelector(SELECTORS.quantityComponent),
            variantSelection: group.querySelector(SELECTORS.variantSelection),
            addToCartButton: group.querySelector(SELECTORS.addToCartButton),
        }
    }
}

/*
Variant image lightbox (offer-pages-testing-2)
Open is declarative via custom-modal (data-action="modal:open"); these handlers
only manage which card is active and reuse the line-select path to add.
Nav order mirrors the modal rows' visual (flex `order`) sequence, so a variant
order override reorders the lightbox exactly as it reorders the modal.
*/
function handleLightboxOpen(event, el, data) {
    void (event, data);
    if (!el) return;

    const list = document.querySelector(SELECTORS.lightboxList);
    if (!list) return;

    // Mirror the modal's current discount/preorder state so the lightbox price
    // matches the row — price spans are revealed by the [data-active-discount-id] CSS.
    const primary = document.querySelector(SELECTORS.primaryVariantForm);
    if (primary) {
        const discountId = primary.getAttribute(ATTR.activeDiscountId);
        const preorder = primary.getAttribute(ATTR.preorderActive);
        if (discountId) list.setAttribute(ATTR.activeDiscountId, discountId);
        if (preorder) list.setAttribute(ATTR.preorderActive, preorder);
    }

    const cards = getOrderedLightboxCards(list);
    if (!cards.length) return;

    // Sync each card's stepper to its variant's current row quantity.
    cards.forEach((card) => {
        const cardVariantId = card.getAttribute('data-variant-id');
        const rowInput = getVariantRowInput(cardVariantId);
        const qty = rowInput ? parseInt(rowInput.value, 10) || 0 : 0;
        syncLightboxQty(cardVariantId, qty);
    });

    const variantId = el.getAttribute('data-lightbox-variant');
    const startIndex = cards.findIndex((card) => card.getAttribute('data-variant-id') === variantId);

    setActiveLightboxCard(list, cards, startIndex < 0 ? 0 : startIndex);
}

function handleLightboxNav(event, el, data) {
    void (event, data);
    if (!el) return;

    const list = el.closest(SELECTORS.lightboxList);
    if (!list) return;

    const cards = getOrderedLightboxCards(list);
    if (!cards.length) return;

    const current = Number(list.getAttribute('data-active-index')) || 0;
    const direction = el.getAttribute('data-lightbox-nav') === 'prev' ? -1 : 1;

    setActiveLightboxCard(list, cards, current + direction);
}

// Order the lightbox cards to match the modal rows' visual sequence. A variant
// order override reorders the rows via CSS `order:` (visual only — the DOM order
// is unchanged), so we read each row's computed `order` and sort the cards the way
// flexbox lays the rows out: by `order` asc, then DOM position. Reading the computed
// result (not the override rules) keeps the modal rows the single source of truth and
// covers every override case, including the option-handle fallback. Rows a template
// has hidden are dropped, so the lightbox rotation shows exactly what the modal shows.
// Falls back to DOM order when there's nothing to reorder or a row/card can't be matched.
function getOrderedLightboxCards(list) {
    const cards = Array.from(list.querySelectorAll(SELECTORS.lightboxCard));
    if (cards.length < 2) return cards;

    const cardByVariant = new Map(
        cards.map((card) => [card.getAttribute('data-variant-id'), card])
    );

    const rows = Array.from(document.querySelectorAll(SELECTORS.variantLineRow));
    if (!rows.length) return cards;

    const matched = rows
        .map((row, domIndex) => {
            // One style read per row: `order` gives the visual sequence, `display`
            // tells us whether the template hid the row (offer templates hide variants
            // via section custom_css). Computed `display` rather than offsetParent or
            // checkVisibility, because those also report "hidden" for every row while
            // the selection modal is closed.
            const style = window.getComputedStyle(row);

            return {
                card: cardByVariant.get(row.getAttribute('data-display-variant-id')),
                hidden: style.display === 'none',
                order: parseInt(style.order, 10) || 0,
                domIndex,
            };
        })
        .filter((entry) => entry.card);

    // Only trust the rows once every card has matched one — a card we can't place
    // would otherwise be dropped from the rotation rather than merely reordered.
    if (matched.length !== cards.length) return cards;

    return matched
        .filter((entry) => !entry.hidden)
        .sort((a, b) => a.order - b.order || a.domIndex - b.domIndex)
        .map((entry) => entry.card);
}

function setActiveLightboxCard(list, cards, index) {
    const count = cards.length;
    if (!count) return;

    const nextIndex = ((index % count) + count) % count;

    cards.forEach((card, cardIndex) => {
        card.classList.toggle('is-active', cardIndex === nextIndex);
    });

    list.setAttribute('data-active-index', String(nextIndex));
}

function handleLightboxAdd(event, el, data) {
    void (event, data);
    if (!el) return;

    const variantId = el.getAttribute('data-variant-id');
    if (!variantId) return;

    // Populate the stepper in place (qty -> 1) and keep the lightbox open.
    setVariantQuantityFromLightbox(variantId, 1);
}

function handleLightboxQty(event, el, data) {
    void (event, data);
    if (!el) return;

    const variantId = el.getAttribute('data-variant-id');
    if (!variantId) return;

    const input = getVariantRowInput(variantId);
    if (!input) return;

    const current = parseInt(input.value, 10) || 0;
    const next = el.getAttribute('data-lightbox-qty-dir') === 'down' ? current - 1 : current + 1;

    setVariantQuantityFromLightbox(variantId, next);
}

// The offer engine only counts quantity inputs in the primary modal form, so the
// lightbox drives the matching row's input (the source of truth) and mirrors it.
function getVariantRowInput(variantId) {
    const component = document.querySelector(`${SELECTORS.quantityComponent}[data-variant-id="${variantId}"]`);
    if (!component) return null;

    const group = captureQuantityGroup(component);
    if (!group || Object.keys(group).length === 0) return null;

    return group.elements.input;
}

function setVariantQuantityFromLightbox(variantId, quantity) {
    const input = getVariantRowInput(variantId);
    if (!input) return;
    if (input.readOnly && quantity > Number(input.value)) return;

    const next = Math.max(0, quantity);
    input.value = String(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));

    syncLightboxQty(variantId, next);
}

function syncLightboxQty(variantId, quantity) {
    const group = document.querySelector(`[data-lightbox-qty-group][data-variant-id="${variantId}"]`);
    if (!group) return;

    group.setAttribute(ATTR.selectedQuantity, String(quantity));
    if (quantity >= 1) {
        const value = group.querySelector('[data-lightbox-qty-value]');
        if (value) value.textContent = String(quantity);
    }
}

function handlePreorderToggleClick(event, el, data) {
    void (event, data);
    if (!el) return;

    const preorderActive = el.dataset.toggleValue;
    updateSelectionForm({ preorder: preorderActive });
    sizeInlineListViewport();
}

function handleQuantityInput(event, el, data) {
    void event;
    if (!el) return;

    const group = captureQuantityGroup(el);
    if (!group || Object.keys(group).length === 0) return;

    group.wrapper.setAttribute(ATTR.selectedQuantity, group.elements.input.value);
    handleBaseQuantityChange(event, el, data);

}

function handleModalClose(event, el, data) {
    void (event, data);
    if (!el) return;
    const { modal, inputs } = captureModalElements(el);
    if (!inputs || inputs.length === 0) return;

    setTimeout(() => {
        inputs.forEach((input) => {
            const group = captureQuantityGroup(input);
            if (group && group.wrapper) group.wrapper.setAttribute(ATTR.selectedQuantity, "0");
            input.value = '0';
        });
        inputs[0].dispatchEvent(new Event('input', { bubbles: true }));
    }, 250);
}

function captureModalElements(el) {
    const modal = el.closest('custom-modal');
    if (!modal) return null;

    const selectorGroup = modal.querySelector(SELECTORS.variantSelection);
    if (!selectorGroup) return null;
    const inputs = selectorGroup.querySelectorAll(SELECTORS.quantityInput);

    return { modal, inputs}

}


/* ———————————————————————————————————————— */
/* shared utilities */
/* ———————————————————————————————————————— */

function handleScrollTop(event, el, data) {
    void (event, el, data);
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

function handleScrollSelection(event, el, data) {
    void (event, el, data);
    const target = document.querySelector(SELECTORS.preorderTogglePills)
        || document.querySelector(SELECTORS.primaryVariantForm);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function moneyRemoveTrailing(value, removeTrailing) {
    if (!removeTrailing) return value;
    const separator = window.localeDetails?.separators?.decimal || ".";
    return value.replace(`${separator}00`, '');
}

function formatMoneyDeep(value, removeTrailing = true, key = '') {
    if (value == null) return value;

    // Handle percentages
    if (typeof value === 'number' && key.includes('percent') || key.includes('percentage')) return `${value}%`;
    if (typeof value === 'number') return moneyRemoveTrailing(formatMoneyFromCents(value), removeTrailing);
    if (Array.isArray(value)) return value.map((item) => formatMoneyDeep(item, removeTrailing, key));

    if (typeof value === 'object') {
        const out = {};
        Object.entries(value).forEach(([k, val]) => {
            out[k] = formatMoneyDeep(val, removeTrailing, k);
        });
        return out;
    }

    return moneyRemoveTrailing(value, removeTrailing);
}

function formatMoneyFromCents(value) {
    const amountInCents = Number(value);
    if (!Number.isFinite(amountInCents)) return '';

    const locale = util.normalize.text(window.localeDetails?.locale || 'en-US');
    const currencyCode = util.normalize.text(window.localeDetails?.currency?.iso_code || 'USD');
    const amount = amountInCents / 100;
    const separators = window.localeDetails?.separators;

    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).formatToParts(amount).map((part) => {
            // Shopify's money separators can differ from the storefront language locale.
            if (part.type === 'decimal') return separators?.decimal ?? part.value;
            if (part.type === 'group') return separators?.thousands ?? part.value;
            return part.value;
        }).join('');
    } catch (error) {
        void error;
        const formattedAmount = amount.toFixed(2).replace('.', separators?.decimal || '.');
        return `${window.localeDetails?.currency?.symbol || '$'}${formattedAmount}`;
    }
}

/* ———————————————————————————————————————— */
/* cart orchestration */
/* ———————————————————————————————————————— */

// LAZY CART RESET

function extractPageOfferHandle() {
    const element = document.querySelector('script[data-offer-config="offer"][data-offer-page]');
    if (!element || !element.dataset.offerHandle) return null;
    return element.dataset.offerHandle;
}

function extractPageGiftPillStyle() {
    const element = document.querySelector(`[${ATTR.giftPillStyle}]`);
    if (!element || !element.dataset.giftPillStyle) return null;
    return element.dataset.giftPillStyle;
}

/*
Alternate variant imagery (A/B). The cart drawer is global and can't read the offer
page's template, so the page stamps its style onto a cart attribute the same way the
gift pills do. Returning null on a control page writes an empty value, which clears
the flag — a cart can't get stuck rendering alternate imagery after the shopper
moves from the test page to the control page.
*/
function extractPageVariantImageStyle() {
    const element = document.querySelector(`[${ATTR.variantImageStyle}]`);
    if (!element || !element.dataset.variantImageStyle) return null;
    return element.dataset.variantImageStyle;
}

/*
Subscription gift (A/B). Same stamp-onto-cart-attribute mechanism as the pills and
variant imagery above: the engine and the (global) cart drawer read the mode from the
cart, and a control page clears it by parsing null.
*/
function extractPageGiftSubMode() {
    const element = document.querySelector(`[${ATTR.giftSubMode}]`);
    if (!element || !element.dataset.giftSubMode) return null;
    return element.dataset.giftSubMode;
}

function extractPageGiftSubProducts() {
    const element = document.querySelector(`[${ATTR.giftSubProducts}]`);
    if (!element || !element.dataset.giftSubProducts) return null;
    return element.dataset.giftSubProducts;
}

function extractPageGiftSubInterval() {
    const element = document.querySelector(`[${ATTR.giftSubInterval}]`);
    if (!element || !element.dataset.giftSubInterval) return null;
    return element.dataset.giftSubInterval;
}

// The offer handle that stamped the mode: binds the subscription-gift behavior to
// THIS page's offer, so later offer swaps (popup, ?offer URLs, market swap — which
// stamp only _offer_handle) can't plan-ify a different offer's gifts.
function extractPageGiftSubOffer() {
    if (!extractPageGiftSubMode()) return null;
    return extractPageOfferHandle();
}

/*
Shipping countdown (A/B). offer-shipping-countdown.js stamps the delivery promise the card
is showing onto the card, and the order keeps it as a cart attribute so promised dates can
be checked against real deliveries. Pages without the card parse null, which clears it; a
card showing nothing (still loading, preorder selected, no estimate) parses '' and clears it too.
*/
function extractPageShippingPromise() {
    const element = document.querySelector(`[${ATTR.shippingPromise}]`);
    if (!element) return null;
    return element.dataset.shippingPromise || '';
}

async function ensurePreparedOfferCart(options = {}) {
    if (hasPreparedCart) {
        return {
            cart: null,
            reason: options.reason || 'cached',
            didUpdate: false,
            updates: null,
        };
    }

    if (prepPromise) return prepPromise;

    prepPromise = (async () => {
        const hydrated = parseHydrationState();
        if (!hydrated) {
            return {
                cart: null,
                reason: options.reason || 'missing-state',
                didUpdate: false,
                updates: null,
            };
        }

        const response = await window.offerEngine.cartFetch('get', {}, true);
        if (!response.ok) {
            throw new Error(`Failed to fetch cart state (${response.status})`);
        }

        const cart = await response.json();
        const discounts = Array.isArray(hydrated?.params?.discounts)
            ? hydrated.params.discounts
            : [];

        const updates = parseCartUpdatesRequired(cart, discounts, hydrated);

        const hasAttributeUpdates = Array.isArray(updates.attributes) && updates.attributes.length > 0;
        const hasItemUpdates = Array.isArray(updates.items) && updates.items.length > 0;
        const hasDiscountUpdates = Array.isArray(updates.discount_codes) && updates.discount_codes.length > 0;

        if (!hasAttributeUpdates && !hasItemUpdates && !hasDiscountUpdates) {
            hasPreparedCart = true;
            await window.offerEngine.handleCartResponse({ confirmed_cart: cart }, true);

            return {
                cart,
                reason: options.reason || 'no-op',
                didUpdate: false,
                updates,
            };
        }

        const body = {
            updates: {},
            attributes: {},
        };

        if (hasItemUpdates) {
            updates.items.forEach(({ key, quantity }) => {
                if (!key) return;
                body.updates[key] = Number(quantity) || 0;
            });
        }

        if (hasAttributeUpdates) {
            updates.attributes.forEach(({ key, value }) => {
                if (!key) return;
                body.attributes[key] = value ?? '';
            });
        }

        if (hasDiscountUpdates) body.discount = updates.discount_codes.join(',');

        const updateResponse = await window.offerEngine.cartFetch('update', body, true);
        if (!updateResponse.ok) {
            throw new Error(`Failed to prepare cart (${updateResponse.status})`);
        }

        const updatedCart = await updateResponse.json();
        handleAttributePatches(updatedCart);

        hasPreparedCart = true;
        await window.offerEngine.handleCartResponse({ confirmed_cart: updatedCart }, true);

        return {
            cart: updatedCart,
            reason: options.reason || 'prepared',
            didUpdate: true,
            updates,
        };
    })();

    try {
        return await prepPromise;
    } finally {
        prepPromise = null;
    }
}

function parseCartUpdatesRequired(cart, discounts = [], hydrated = null) {
    const { items = [], attributes = {} } = cart;

    const updateOutputs = {
        attributes: [],
        items: [],
        // Pricing discounts plus apply-only passengers (e.g. free shipping) — the
        // prep update is often the only discount application in a session, so the
        // apply-only titles must ride here too. The engine helper suppresses
        // shipping-type passengers while the cart holds a subscription line.
        discount_codes: [
            ...discounts.map((discount) => discount.title?.toLowerCase()?.trim()),
            ...(window.offerEngine.parseApplicableApplyOnlyTitles?.(hydrated?.params || {}, items) || [])
                .map((title) => title?.toLowerCase?.()?.trim()),
        ].filter(Boolean),
    };

    Object.keys(attributes).forEach((key) => {
        if (ATTRIBUTE_RESET_EXCLUSIONS.includes(key)) return;

        updateOutputs.attributes.push({
            key,
            value: '',
        });
    });

    if (hydrated?.params?.offer?.freeship_mode && hydrated?.params?.offer?.freeship_threshold) {
        updateOutputs.attributes.push({
            key: '_freeship_mode',
            value: hydrated.params.offer.freeship_mode,
        });
        updateOutputs.attributes.push({
            key: '_freeship_threshold',
            value: hydrated.params.offer.freeship_threshold,
        });
    }

    const candidatePreorderState = parsePreorderRuleState(hydrated?.params?.preorder_rules);
    if (candidatePreorderState) {
        updateOutputs.attributes.push({
            key: '_preorder_eligible',
            value: 'true'
        });
        updateOutputs.attributes.push({
            key: '_preorder_ship_delay',
            value: candidatePreorderState.delay.toString(),
        });
    }

    Object.entries(SET_ATTRIBUTE_PARSERS).forEach(([key, parser]) => {
        const parsedValue = parser(attributes[key]);

        const existingIndex = updateOutputs.attributes.findIndex((attribute) => attribute.key === key);

        if (existingIndex > -1) {
            updateOutputs.attributes[existingIndex] = {
                key,
                value: parsedValue ?? '',
            };
            return;
        }

        updateOutputs.attributes.push({
            key,
            value: parsedValue ?? '',
        });
    });

    items.forEach((item) => {
        if (!item?.key) return;
    
        updateOutputs.items.push({
            key: item.key,
            quantity: 0,
        });
    });

    return updateOutputs;
}

// ADD TO CART

function setModalLoadingState(modal, isLoading) {
    modal.classList.toggle('processing', isLoading);
}

async function buildRequestPayload(payload, state) {
    const config = util.clone.obj(window.config.params);
    if (!config) throw new Error('[buildPreRequestPayload]: No config found');
    const cart = window.lastCart || await window.offerEngine.cartFetch('get', {});
    const cartAttributes = cart.attributes || {}

    const { attributes = {}, items = [] } = payload;

    if (Object.keys(attributes).length) {
        if (!config.attributes) config.attributes = {};
        Object.entries(attributes).forEach(([key, value]) => {
            if (!cartAttributes[key] || cartAttributes[key] !== value) {
                config.attributes[key] = value;
            }
        });
    }

    if (state?.preorder_active) config.preorder_rules = state.active_preorder_rules;
    if (state?.active_discount) config.active_discounts = [state.active_discount];

    // Shipping apply-only suppression: when this add introduces (or the cart
    // already holds) a subscription line, the shipping code must move in the same
    // dispatch or checkout shows a "code couldn't be used" banner. Guarded on the
    // offer carrying a shipping apply-only code — absent that, the dispatch is
    // byte-identical to before.
    let followup_discount;
    const applyOnly = config.apply_only_discounts || [];
    if (applyOnly.some((entry) => entry.type === 'Free shipping')) {
        const projectedItems = [...(cart.items || []), ...items];
        const desired = Array.from(new Set([
            ...(config.discounts || []).map((discount) => discount.title),
            ...(window.offerEngine.parseApplicableApplyOnlyTitles?.(config, projectedItems) || []),
        ].filter(Boolean))).map((title) => title.toLowerCase().trim());
        const current = (cart.discount_codes || []).map((discount) => discount.code.toLowerCase().trim());
        const desiredSorted = desired.slice().sort();
        const currentSorted = Array.from(new Set(current)).sort();
        const equal = desiredSorted.length === currentSorted.length
            && desiredSorted.every((value, index) => value === currentSorted[index]);
        if (!equal) followup_discount = desired.join(',');
    }

    return {
        cart,
        config,
        followup_discount,
        request: {
            method: 'add',
            payload: {
                ...(Object.keys(attributes).length ? { attributes } : {}),
                items,
            },
        }
    }
}

async function handleAddToCart(event, el, data) {
    void event;
    if (!el || el.disabled) return;

    // Inline-selection templates render the add button outside any modal.
    const modal = captureModalElements(el)?.modal || null;
    if (modal) setModalLoadingState(modal, true);
    el.disabled = true;

    try {
        await handleOfferCompletion(el, data.state);
    } catch (error) {
        console.error('handleAddToCart failed', error);
    } finally {
        if (modal) setModalLoadingState(modal, false);
        el.disabled = false;
    }
}

async function handleDirectAddToCart(event, el, data) {
    void data;
    if (!el || el.disabled) return;

    event.preventDefault();

    const preorderActive = el.dataset.toggles === 'preorder-active'
        ? el.dataset.toggleValue
        : null;

    if (preorderActive !== null) {
        updateSelectionForm({ preorder: preorderActive });
    }

    el.disabled = true;

    try {
        const hydrated = handleHydration();
        const directState = parseDirectAddState(hydrated.state);
        await handleOfferCompletion(el, directState);
    } catch (error) {
        console.error('handleDirectAddToCart failed', error);
    } finally {
        el.disabled = false;
    }
}

async function handleOfferCompletion(trigger, state) {
    const payload = parseCartAddPayload(state);
    if (!payload?.items?.length) throw new Error('No cart items found in add payload');
    const submit = async (extras = []) => {
        await ensurePreparedOfferCart({ reason: 'submit' });
        const { request, followup_discount } = await buildRequestPayload({
            ...payload, items: [...payload.items, ...extras],
        }, state);
        const requests = followup_discount !== undefined
            ? [request, { method: 'update', payload: { discount: followup_discount } }]
            : [request];
        const success = await window.offerEngine.dispatchCartRequests({
            requests, context: 'offer-page:add', validate_response: true,
        });
        if (!success) throw new Error('Offer cart request failed');
    };
    const upsellRoot = document.querySelector('[data-offer-upsell]');
    upsellRoot?.querySelectorAll(SELECTORS.giftDisplay).forEach((el) => updateGiftDisplayContent(state, el));
    const offerPrices = upsellRoot ? parsePriceStates(state) : null;
    const opened = await window.offerEngine.openOfferUpsell({
        trigger,
        baseTotal: offerPrices?.selections[state.preorder_active ? 'preorder' : 'discount'],
        formatMoney: formatMoneyFromCents,
        complete: completeOfferPurchase,
        // Prepare afresh only on another submission; dismissal itself must not mutate the cart.
        dismiss: () => { hasPreparedCart = false; },
        updateSummary: ({ price, compareExtras }) => {
            const compare = offerPrices.selections.compare + compareExtras;
            const summaryValues = formatMoneyDeep({
                selections: {
                    compare, discount: price, preorder: price,
                    savings: { amount: compare - price, amount_preorder: compare - price },
                },
            });
            updateSummaryContent(state.preorder_active, summaryValues,
                upsellRoot.querySelector(SELECTORS.summaryElement),
                state.base_quantity_selection, state.primary_variant_quantity);
        },
        submit,
    });
    if (!opened) {
        await submit();
        await completeOfferPurchase();
    }
}

async function completeOfferPurchase() {
    if (handleOfferCheckout()) return;
    initCartClosePrepReset();
    openCartDrawer();
    await waitForNextPaint();
    await window.closeAllCustomModals?.({ restoreFocus: false, clearUrl: true });
}

function handleOfferCheckout() {
    const form = document.querySelector('[data-offer-checkout]');
    if (!form) return false;

    // Use the same localized cart POST as the theme's native checkout button.
    form.requestSubmit();
    return true;
}

function parseDirectAddState(state) {
    if (!state) return {};

    const selection = state.preorder_active
        ? state.base_selection_lowest_preorder || state.base_selection_lowest_price
        : state.base_selection_lowest_price;

    return {
        ...state,
        active_selections: selection ? [selection] : [],
        primary_variant_quantity: state.base_quantity_selection,
        baseline_quantity: state.base_quantity_selection,
    };
}

function initCartClosePrepReset() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    cartDrawer.addEventListener('dialog:close', resetFirstInteractionPrep, { once: true });
}

async function parseLatestCart(addResponse) {
    if (!window.lastCart) return await window.offerEngine.cartFetch('get', {});
    const cart = window.lastCart
    cart.items = addResponse.items;
    return cart
}

function handleAttributePatches(response) {
    const attributes = response.attributes;
    if (!attributes) return;

    Object.entries(LOCAL_ATTRIBUTE_SYNC_KEYS).forEach(([key, value]) => {
        if (attributes[key]) {
            window[value] = attributes[key];
        }
    });

}

function parseCartAddPayload(state) {

    const { active_selections, applicable_gifts, preorder_active } = state;
    if (preorder_active && active_selections.some(item => !(item.pricing?.preorder_unit > 0))) {
        throw new Error('Selected color is unavailable for preorder');
    }
    const applicablePreorderRules = parseApplicablePreorderRules(
        state.active_preorder_rules,
        active_selections
    );
    const activePreorderState = preorder_active
        ? parsePreorderRuleState(applicablePreorderRules)
        : null;
    const shouldApplyPreorder = activePreorderState !== null;

    const payload = {
        items: [],
        attributes: {},
    }

    active_selections.forEach((item) => {
        const itemPayload ={
            id: item.id,
            quantity: item.quantity || 1,
            properties: {
                ...(item.pricing?.msrp ? { _local_original_price: item.pricing?.msrp } : {}),
                ...(item.pricing?.compare_override ? { _transformed_at_once: item.pricing.compare_override / 100 } : {}),
            },
        };
        if (shouldApplyPreorder && item.pricing?.preorder_original_unit) {
            itemPayload.properties = {
                ...itemPayload.properties,
                _isPreorder: 'true',
                _preorder_price: item.pricing.preorder_original_unit / 100,
                _preorder_discount_rate: item.pricing.preorder_discount_rate,
                _preorder_market_currency: window.localeDetails?.currency?.iso_code || 'USD',
                _preorder_original_msrp: item.pricing.msrp / 100,
                _added_in_market: window.localeDetails?.market || 'us',
            };
        }
        payload.items.push(itemPayload);
    });

    // Subscription gift (A/B): this path builds gift lines itself (it does not go
    // through the engine's parseGiftsState additions), so it must plan-ify here too.
    // The attribute bundle is read straight off the page DOM rather than the cart —
    // the stamped cart attributes may not exist yet on a first-interaction add.
    const giftSubAttributes = {
        _gift_sub_mode: extractPageGiftSubMode(),
        _gift_sub_products: extractPageGiftSubProducts(),
        _gift_sub_interval: extractPageGiftSubInterval(),
        _gift_sub_offer: extractPageGiftSubOffer(),
        _offer_handle: extractPageOfferHandle(),
    };

    applicable_gifts.forEach((gift) => {
        if (!gift.variant_ids.length) return;
        const quantity = offerEngine.parseGiftQualifyingQuantity(gift, paramsData, active_selections);
        const root = [...document.querySelectorAll('[data-offer-page] [data-gift-variant-options]')]
            .find(el => Number(el.dataset.giftId) === Number(gift.id));
        const choices = root ? offerEngine.parseGiftOptionSelections(root) : [];
        const selections = offerEngine.parseGiftVariantQuantities(gift, quantity, choices);
        selections.forEach(selection => {
            const giftSubPlanId = offerEngine.parseGiftSubscriptionPlanId?.(
                gift.variant_ids.length > 1 ? paramsData : window.config?.params || {},
                gift, giftSubAttributes, selection.id
            );
            payload.items.push({
                id: selection.id, quantity: selection.quantity,
                properties: {
                    _is_gift: 'true',
                    ...(gift.variant_ids.length > 1 ? {
                        _gift_item_id: String(gift.id), _gift_set_id: String(gift.gift_set_id),
                    } : {}),
                },
                ...(giftSubPlanId ? { selling_plan: giftSubPlanId } : {}),
            });
        });
    });

    if (shouldApplyPreorder) {
        payload.attributes = {
            _preorder: 'true',
            _preorder_ship_delay: activePreorderState.delay.toString(),
            _preorder_rules_ids: activePreorderState.ruleIds.join(','),
        };
    }

    // Shipping countdown (A/B): restamp the promise at add time. The first-interaction prep
    // stamped it earlier, and the countdown may have passed the dispatch cutoff since.
    const shippingPromise = extractPageShippingPromise();
    if (shippingPromise !== null) payload.attributes._shipping_promise = shippingPromise;

    if (Object.keys(payload.attributes).length === 0) {
        delete payload.attributes;
    }

    return payload;
}

// async function refreshAndOpenCart() {
//     const cartResponse = await fetch(CART_STATE_PATH, {
//         credentials: 'same-origin',
//         headers: {
//             Accept: 'application/json',
//         },
//     });

//     if (!cartResponse.ok) {
//         throw new Error(`Failed to fetch fresh cart (${cartResponse.status})`);
//     }

//     const cart = await cartResponse.json();

//     const cartUpdated = waitForCartRenderComplete();

//     document.dispatchEvent(
//         new CustomEvent('cart:update', {
//             bubbles: true,
//             detail: {
//                 data: {
//                     itemCount: cart.item_count || 0,
//                     source: 'product-form-component',
//                     cart,
//                 },
//             },
//         })
//     );

//     await cartUpdated;
//     openCartDrawer();
// }

function waitForCartRenderComplete() {
    return new Promise((resolve) => {
        document.addEventListener('cart:updated', resolve, { once: true });
    });
}

function waitForNextPaint() {
    return new Promise((resolve) => {
        window.requestAnimationFrame(resolve);
    });
}

function openCartDrawer() {
    const cartDrawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    if (typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
        return;
    }

    if (typeof cartDrawer.openModal === 'function') {
        cartDrawer.openModal();
        return;
    }

    if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
    }

    cartDrawer.setAttribute('open', '');
    cartDrawer.open = true;
}

/* Cart >> Modal: State Reconciliation */
document.addEventListener('cart:line-quantity-update', (event) => {
    const { quantity, line } = event.detail;
    const updatedVariant = getCartLineVariant(line);

    // The one primary selection form lives inside the modal on modal templates
    // and directly on the page on inline_variant_selection templates — scoping
    // to it (not the modal) reconciles drawer edits in both layouts.
    const selection = document.querySelector('[data-content="variant-selection"][data-selection-type="primary"]');
    if (!selection) return;

    const variantSelector = selection.querySelector(`quantity-selector-component[data-variant-id="${updatedVariant}"]`);
    if (!variantSelector) return;

    const input = variantSelector.querySelector('input');
    if (!input) return;

    input.value = quantity;
    input.dispatchEvent(new Event('input', { bubbles: true }));
});

function getCartLineVariant(index) {
    const cartLine = document.querySelector(`[ref="cartItemRows[]"][data-line-index="${index}"]`);
    if (!cartLine || !cartLine.dataset.lineVariantId) return null;
    return cartLine.dataset.lineVariantId;
}
